/* A BUILD IS ONE THING. THE CART DID NOT KNOW THAT. — Sapphire Row
   ---------------------------------------------------------------------------
   `RB.addToCart` posts a build as TWO line items joined by `_build_id`, and
   nothing outside ring-builder.js had ever read that property. So the two lines
   were independent: remove the gemstone and the MOUNTING stayed, priced and
   checkout-able on its own. Found by the owner 2026-08-02 by doing exactly that.

   That is not a cosmetic problem. A bare mounting is not a product this business
   sells — `meta-tags.liquid` noindexes `ring-builder-setting` precisely because it
   is "a bare mounting a shopper could mistake for a ring", and the settings were
   deliberately pulled out of new-arrivals and search for the same reason. Selling
   one is shipping a customer a half-finished ring with no stone in it.

   THE RULE IS ASYMMETRIC, and deliberately so (owner, 2026-08-02):

       remove the STONE   -> the setting CANNOT stand alone   -> both go
       remove the SETTING -> a loose stone is a real product   -> the stone stays

   So this never blocks anyone from buying a gemstone on its own; it only refuses
   to sell the metal half by itself.

   ⚠️ WHY A REPAIR PASS AND NOT ONLY A UI CHANGE. Grouping the lines behind one
   Remove control (below) stops it happening from here on. It does nothing about a
   cart that ALREADY holds an orphan — carts persist for days, and
   `/cart/change.js` can be reached without this page. So the pass runs on every
   cart render and heals what it finds.

   ⚠️ THIS IS THE CART, NOT THE CHECKOUT. Shopify's checkout is not themeable
   here, so it still lists the lines separately. Merging them into ONE line is a
   Cart Transform Function (Shopify Functions), which this store's plan does not
   allow. This file makes the CART behave correctly and read as one item; it
   cannot change what checkout draws.

   2026-09-07: A PENDANT BOUGHT WITH ITS MATCHING CHAIN from the product page
   (`_chain_set`, matching-chain.js) groups the same way. 2026-09-09: and an earring
   JACKET bought with its matched studs (`_jacket_set`, jacket-studs.js). The orphan
   guard stays scoped to `_build_id`: a pendant, a chain, a pair of jackets and a
   pair of studs are each a product we sell on its own.

   2026-09-17: ONE ITEM, ONE ROW (owner). The build was drawn as a card of its own:
   no quantity control, its remove icon and its total in other places than every
   other line's, its render not centred. The owner asked for one rule set across the
   site (https://claude.ai/artifact/CitZjwd5evUJuTupBPHEC3), approved the same day:
     · one purchase is one cart item, with its parts listed inside it;
     · every item uses the same columns — Product, Availability, Quantity, Total;
     · every item has the theme's − 1 + control and remove control, and on a
       grouped item they act on ALL of its parts together;
     · a one-of-a-kind stone (or a build set with one) stays at 1, + greyed out;
     · a Ring Sizing charge is a line inside its ring, never an item of its own.
   So a group is now drawn IN the theme's own row for its main line — the setting,
   the pendant, the jackets, the ring — and the other lines' rows are hidden. And a
   ring bought in a size other than its stocked one, which arrives with a Ring
   Sizing charge joined by `_sr_pair` (the ring-size block on product.rings.json), is
   the fourth kind of group. */
(function () {
  'use strict';

  var BUILD = '_build_id', PART = '_rb_part';
  /* FINAL SALE (owner 2026-09-15, in line with the supplier's returns policy). The copy
     MUST equal RB.FINAL_SALE in ring-builder.js — returns-final-sale/test_final_sale.py
     asserts it. The value on the line wins; this copy is only for builds that reached
     the cart before the note shipped (see backfillFinalSale). */
  var FINAL_SALE = 'Final sale — made and set to order, not returnable';
  var FINAL_SALE_KEY = 'Returns';
  /* A BARE SETTING IS NEVER SOLD ON ITS OWN (owner 2026-09-17: settings are not available on the storefront, only in
     the builder). The theme draws no buy control for a setting (sr-builder-setting.liquid), but a cart from before
     that, a hand-made /cart/add.js request or any other path the theme cannot see can still hold one.
     🚨 THE PRODUCT TYPE DECIDES, NEVER THE LINE'S OWN PROPERTIES (Codex review-mu54pwk3-npeono). `_build_id`,
     `_rb_part`, `Component`, `_chain_set` and `_jacket_set` are whatever the request that added the line said, so a
     pasted request can claim any of them. A line typed as a setting stays ONLY as the one setting of a structurally
     valid build (validBuildSetting); every other setting-typed line is removed.
     MUST equal the values of fix_setting_storefront_exposure.py COHORTS (builder-settings-hidden/test_cart_orphans.cjs).
     Live census 2026-09-17 and 2026-09-23: every non-archived product of these types (270) is a builder setting. */
  var SETTING_TYPES = ['Engagement Ring Setting', 'Pendant Setting', 'Earring Setting'];
  /* The store's product types that are never a gemstone (live census 2026-09-23: 48 types; every one of the 16,350
     builder centre and side stones is a gemstone type; builder-settings-hidden/census_types.py). A build's centre line of one of these types is not a centre
     stone. A NEGATIVE list on purpose: a gemstone type a later import adds must never break a real build, while a
     jewelry type missing here only lets a hand-made cart through, which no theme script can fully stop (checkout
     links skip the cart). test_cart_orphans.cjs [7] checks it against the census. */
  var NOT_A_CENTRE_TYPES = ['Ring', 'Pendant', 'Necklace', 'Earring', 'Earrings', 'Bracelet', 'Anklet', 'Service',
                            'INTERNAL TEST'];
  // What a BUILD is, in the shopper's words (owner 2026-09-16). Not "made to order": that is the label the
  // cart's Liquid puts on an ordinary catalog piece made on demand, and a build is chosen and set for them.
  var CUSTOM_PIECE = 'Custom piece';
  var CUSTOM_WHEN = 'Made and set to order. Ships in 2–4 weeks';
  // The chip look, option B (owner 2026-09-16): the SAME tag the Liquid snippet sr-line-availability draws for
  // "In stock" and "Made to order" — status, then when it ships, on two lines — in a third color. Built from the
  // same inline values so the three read as one set.
  function chip(status, when, fg, bg) {
    var el = document.createElement('span');
    el.className = 'rb-group__avail';
    el.setAttribute('style', 'display:flex;width:fit-content;max-width:100%;align-items:flex-start;gap:.5em;margin:.6em 0 0;' +
      'padding:.4em .9em .45em .7em;border-radius:.9em;font-size:.86em;line-height:1.3;' +
      'letter-spacing:.01em;text-transform:none;color:' + fg + ';background:' + bg);
    var dot = document.createElement('span');
    dot.setAttribute('aria-hidden', 'true');
    dot.setAttribute('style', 'width:.45em;height:.45em;margin-top:.425em;border-radius:50%;background:currentColor;flex:none');
    var text = document.createElement('span');
    text.className = 'sr-avail__text';
    text.setAttribute('style', 'display:flex;flex-direction:column;min-width:0');
    var head = document.createElement('span');
    head.setAttribute('style', 'font-weight:600');
    head.textContent = status;
    var sub = document.createElement('span');
    sub.className = 'sr-avail__when';
    sub.setAttribute('style', 'font-weight:400');
    // Never split across lines: a number range ("2–" / "4 weeks"), a range with its weeks, or "business days" —
    // the same units the Liquid chip keeps whole, so no word is left alone on a line.
    String(when).split(/(\d+–\d+ weeks|\d+–\d+|business days)/).forEach(function (part, i) {
      if (!part) return;
      if (i % 2) {
        var range = document.createElement('span');
        range.setAttribute('style', 'white-space:nowrap');
        range.textContent = part;
        sub.appendChild(range);
      } else {
        sub.appendChild(document.createTextNode(part));
      }
    });
    text.appendChild(head);
    text.appendChild(document.createTextNode(' '));
    text.appendChild(sub);
    el.appendChild(dot);
    el.appendChild(text);
    return el;
  }

  /* 🚨 A PAIR IS NOT ONLY A BUILD (owner, 2026-09-07: a pendant bought WITH its
     matching chain from the PRODUCT page arrived as two loose cart lines, while the
     same pendant built in the builder collapsed into one card). Scripts that post
     joined lines each speak their own vocabulary:

       ring-builder.js   RB.addToCart   { _build_id, _rb_part, Component: "Setting (1 of 3)" }
       matching-chain.js (product page) { _chain_set,          'Sold as': "Pendant (1 of 2)" }
       ring-size block   (ring page)    { _sr_pair } on the ring and on its Ring Sizing charge

     THE KEYS ARE A NAMED LIST, not a second `||` buried in a helper: a list is
     auditable, and WHICH key formed a group is recorded on its row
     (`data-rb-group`) because the rules below differ by key — `repair()` removes
     build lines on `_build_id` groups ONLY (see it).

     ⚠️ ORDER IS PRECEDENCE. A line carrying more than one key files under the first.
     No live script writes two: the builder's own review-step chain carries
     `_build_id` + `_rb_part: 'chain'`, never `_chain_set`. */
  var CHAIN_SET = '_chain_set';
  var JACKET_SET = '_jacket_set';
  var SR_PAIR = '_sr_pair';
  // The service product a sizing charge is bought as (create_sizing_product.py). Its lines are the charge; every
  // other line on the same `_sr_pair` token is the ring.
  var SIZING_HANDLE = 'ring-sizing';
  // Owner 2026-10-06 (docs/handoffs/ring-in-stock-sizes.md): its in-stock twin, sold with a size the supplier confirmed
  // ships as fast, is the same charge in every way this file cares about.
  var SIZING_TWIN_HANDLE = 'ring-sizing-in-stock';
  function isSizing(it) { return !!it && (it.handle === SIZING_HANDLE || it.handle === SIZING_TWIN_HANDLE); }
  /* ACCENT STONES (colored pavé, the full menu; owner option 1, 2026-11-03). A builder ring with gemstone accents is
     its design's EMPTY mounting (accent option RB.ACCENT_VALUE in ring-builder.js) plus an Accent Stones line
     (`_rb_part: 'accent'`). Neither stands alone: an empty mounting without its accent line is a ring with empty
     seats, and an accent line without its ring pays for nothing, so repair() removes either one left alone. The
     mounting is known by its own variant option as well as by the property the builder writes. */
  var ACCENT_VALUE = 'Gemstone Accents';
  function isEmptyMount(it) {
    return !!it && (!!props(it)['_rb_accent'] || (it.variant_options || []).indexOf(ACCENT_VALUE) >= 0);
  }
  var PAIR_KEYS = [
    BUILD,       // the three builders: setting + centre (+ sides) (+ chain)
    CHAIN_SET,   // a pendant PRODUCT page + its matching chain (matching-chain.js)
    JACKET_SET,  // an earring-JACKET page + its matched studs (jacket-studs.js)
    SR_PAIR      // a RING page + the Ring Sizing charge for the size chosen there (owner 2026-09-17)
  ];
  // The product-page pair's VISIBLE property. It is the only copy on those lines —
  // no `_rb_part`, no `Component` — so `roleOf` reads it third, and `renumber()`
  // rewrites its "(n of m)" counter exactly as it rewrites Component's.
  var SOLD_AS = 'Sold as';
  // The "(n of m)" counter that both Component and Sold as end in — see renumber().
  var PART_OF_RE = /\((\d+) of (\d+)\)\s*$/;

  /* ENGRAVING (owner 2026-09-26: an engraving typed on a pendant bought with its chain never reached the cart, and
     "I don't think it's in line with how other buildable pieces look in the cart"). The engraving block
     (theme_snippets/engraving_property.liquid, pasted once on each of five product templates) writes the shopper's
     text onto the piece's OWN line as `Front Initial` / `Back Initial`. Those names are what checkout, the order,
     the packing slip and the owner's relay to the supplier read, so they stay exactly as they are; only the cart's
     drawing of them changes. The engraving reads as one of the piece's own details, "Engraving: FFA" under its
     options (engravingMeta), and the item says once what engraving makes it: custom work is final sale (owner
     2026-09-15, the supplier's policy;
     the product page already says "Engraved pieces are final sale"). A line that already carries its own `Returns`
     note (a sized ring) keeps that one: it is final sale either way (saleOf). */
  /* + the ring builder's inside-band engraving (owner 2026-10-06): RB.addToCart writes `Inside engraving`
     on the setting line, with `Engraving font` and, for a color fill, `Engraving color` (engravingMeta). */
  var ENGRAVING = [['Front Initial', 'front'], ['Back Initial', 'back'], ['Inside engraving', 'inside']];
  var ENGRAVING_HOW = ['Engraving font', 'Engraving color'];
  var ENGRAVED_FINAL_SALE = 'Final sale — engraved to order, not returnable';
  // "Pendant + engraving": the piece's own product type (the five engravable types, census 2026-09-26).
  var ENGRAVED_KIND = { Pendant: 'Pendant', Necklace: 'Necklace', Ring: 'Ring', Bracelet: 'Bracelet',
                        Earring: 'Earrings', Earrings: 'Earrings' };
  var ENGRAVED = 'data-rb-engraved';      // on the row of a piece engraved on its own (drawEngraved)
  /* 🚨 NO VISIBLE PROPERTY IS WIPED WITHOUT BEING SHOWN (owner 2026-09-26). A grouped item is drawn over the theme's
     own details, which list every visible property a line carries, and the engraving on a pendant bought with its
     chain went with them. Every visible property is now either drawn by this file in its own words — these — or
     listed the theme's way, "Name: value", by otherProps(), so a property some later block adds shows up rather
     than vanishing. ⚠️ The builder's `Part of`, `Earring backs` and `Quantity` are named here on purpose: the approved
     build item (owner 2026-09-17) does not show them. Its `Ring size` is drawn on the setting's line (buildRingSize).
     (`Part of`, "Custom ring · build MUJGET5K7BXK", is on every builder line; missed here until a real cart showed it
     on each piece, 2026-09-27.) */
  var DRAWN = [SOLD_AS, 'Component', 'Part of', FINAL_SALE_KEY, 'Ring Size', 'Ring size', 'For', 'Earring backs', 'Quantity']
    .concat(ENGRAVING.map(function (e) { return e[0]; })).concat(ENGRAVING_HOW);

  // Styles ride with the module rather than in their own asset: this is one
  // self-contained behaviour, and a second file is a second thing to remember to
  // push. Sizes are em so they follow the cell they sit in (this theme's rem is
  // 9.36px in declarations); colours come from the theme's tokens where it has one.
  // ⚠️ Injected CSS is appended to <head>, so it comes AFTER the theme's sheets and
  // an equal-specificity declaration here WINS. Nothing here restates the theme's
  // own type for a product name: the one line that is a product title keeps
  // `.cart-item__name`.
  var CSS = '' +
    // `.cart-item__details > *` caps every child at 30rem; the group's box is the cell's only child.
    '.cart-item__details>.rb-group{max-width:none}' +
    '.rb-group{display:flex;flex-direction:column;gap:.4rem;min-width:0}' +
    '.rb-group__label{font-size:.75em;font-weight:600;letter-spacing:.14em;text-transform:uppercase;opacity:.75}' +
    '.rb-group__actions{display:flex;flex-wrap:wrap;align-items:baseline;column-gap:1.6rem;row-gap:.2rem}' +
    // 🚨 ONE LOOK FOR EVERY LINK ON A GROUP (owner 2026-09-17: "Change" should be underlined like "Remove
    // chain" and the spacing for both should be the same). An <a> and a <button> reset to the same thing.
    '.rb-group__link{font:inherit;color:inherit;background:none;border:0;padding:0;margin:0;cursor:pointer;' +
      'text-decoration:underline;text-underline-offset:.3rem;text-decoration-thickness:1px}' +
    '.rb-group__link:disabled{opacity:.5;cursor:default}' +
    '.rb-group__sub{display:flex;flex-wrap:wrap;align-items:baseline;gap:.2rem .6rem}' +
    '.rb-group__parts{display:flex;flex-direction:column}' +
    '.rb-group__part{display:flex;flex-direction:column;gap:.2rem;padding:.8rem 0;min-width:0}' +
    '.rb-group__part:first-child{padding-top:.2rem}' +
    '.rb-group__part+.rb-group__part{border-top:1px solid rgba(35,74,103,.12)}' +
    // A pair's lines carry their own photographs (rule 6: "a pendant and its chain keep a small photo each").
    '.rb-group__part--media{display:grid;grid-template-columns:56px minmax(0,1fr);column-gap:1.4rem;align-items:center}' +
    '.rb-group__thumb{width:56px;height:56px;object-fit:contain;background:#fff;border-radius:.3rem}' +
    '.rb-group__parttext{display:flex;flex-direction:column;gap:.2rem;min-width:0}' +
    '.rb-group__tag{font-size:.72em;letter-spacing:.1em;text-transform:uppercase;opacity:.7}' +
    '.rb-group__name{line-height:1.35}' +
    '.rb-group__note{font-size:.92em;opacity:.8}' +
    // A property this file has no words of its own for, listed the theme's way ("Name: value"; see DRAWN).
    '.rb-group__props{margin:0}.rb-group__props dt,.rb-group__props dd{display:inline;margin:0}' +
    '.cart-drawer .rb-group__props{font-size:var(--text-size-tiny)}' +
    // In the drawer the theme sets a line's price and options in its tiny size; a group's price, links and lines
    // follow it there, so "$575" and "Change" beside it are one size (the options line's look is the templates' own,
    // `.sr-line-options`, which the group's meta line wears).
    '.cart-drawer .rb-group__actions,.cart-drawer .rb-group__sub,.cart-drawer .rb-group__note{font-size:var(--text-size-tiny)}' +
    '.rb-group .sr-avail,.rb-group .rb-group__avail{margin:.2rem 0 0!important}' +
    '.rb-group__chips{display:flex;flex-direction:column;gap:.6rem}' +
    '.rb-group__chips .sr-avail,.rb-group__chips .rb-group__avail{margin:0!important}' +
    // The composed render keeps the photo column's box; `cover` would crop the ring it pictures.
    '.rb-group__render{object-fit:contain!important;background:#fff}' +
    '.rb-group__render--own{display:block;width:100%;height:auto;aspect-ratio:1}' +
    // A pair has no one photograph (see planOf): its details take the photo's column too, from its left edge.
    '.rb-group--pair>.cart-item__media{display:none}' +
    '@media screen and (min-width:750px){.cart-items .rb-group--pair>td.cart-item__details{padding-inline-start:0}}' +
    '@media screen and (max-width:749px){.cart-items .rb-group--pair>.cart-item__details{grid-column:1/-1}}' +
    '.rb-cart-note{margin:0 0 1.2rem;padding:1rem 1.2rem;border-left:2px solid #a38245;' +
      'background:rgba(163,130,69,.06);color:#234A67;font-size:.92em}' +
    // In the cart drawer (any page but /cart): under the header, with the header's own side padding.
    '.drawer__inner>.rb-cart-note{margin:1.5rem 2.5rem 0}' +
    '@media screen and (min-width:1024px){.drawer__inner>.rb-cart-note{margin:1.5rem 3.5rem 0}}';

  // The note under a quantity held at 1 — the same element and words the cart's Liquid prints under a loose stone.
  var QTY_NOTE_STYLE = 'margin:.6rem 0 0;font-size:.86em;line-height:1.35;opacity:.75;max-width:18rem';

  (function injectCss() {
    if (document.getElementById('rb-cart-pair-css')) return;
    var s = document.createElement('style');
    s.id = 'rb-cart-pair-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  })();

  function props(item) { return item.properties || {}; }
  // `_build_id` ONLY, by design: `repair()` reads its groups through this, and the
  // orphan guard must never see a product-page pair (see repair()).
  function buildOf(item) { return props(item)[BUILD] || null; }
  function partOf(item) { return props(item)[PART] || null; }
  // The pair a line belongs to — `{ key, id }` for the FIRST of PAIR_KEYS it carries,
  // or null for an ordinary line. `group()` files on BOTH halves, so two ids that
  // happened to agree across keys cannot merge a ring with a pendant.
  function pairOf(item) {
    var p = props(item), i;
    for (i = 0; i < PAIR_KEYS.length; i++) {
      if (p[PAIR_KEYS[i]]) return { key: PAIR_KEYS[i], id: String(p[PAIR_KEYS[i]]) };
    }
    return null;
  }

  function isSettingType(item) { return SETTING_TYPES.indexOf(item.product_type) >= 0; }

  /* IS THIS SETTING-TYPED LINE THE ONE SETTING OF A REAL BUILD? `group` is every line sharing its `_build_id`. All of:
       1. it reads as the SETTING: `_rb_part: 'setting'`, or a legacy build's Component ("Setting", "Both mountings");
       2. it is the only setting-typed line in the build (RB.addToCart posts exactly one mounting line per build);
       3. a DIFFERENT line reads as the centre STONE and its product is neither a setting nor a finished piece,
          chain or service (NOT_A_CENTRE_TYPES).
     A forged `_build_id` alone, a setting that says it is the stone, two mountings sharing one stone, or a chain
     labelled as the centre all fail. The real builders' lines pass (test_cart_orphans.cjs [6] runs MAIN's
     ring-builder.js). QUANTITY IS NOT TESTED HERE: a real build's setting above its stone's quantity is brought DOWN
     by the released rule below ("A SETTING NEVER OUTNUMBERS ITS CENTRE STONE", Codex review-mu5i3ght-gafx1o), never
     removed (rebuilt 2026-09-23 on MAIN's bytes; test_cart_orphans.cjs [9]). */
  function validBuildSetting(item, group) {
    if (roleOf(item) !== 'setting') return false;
    if (group.filter(isSettingType).length !== 1) return false;
    return group.some(function (c) {
      return c !== item && c.key !== item.key && !isSettingType(c) && roleOf(c) === 'stone' &&
             NOT_A_CENTRE_TYPES.indexOf(c.product_type) < 0 && (Number(c.quantity) || 0) > 0;
    });
  }

  // Older builds (added before `_rb_part` shipped) have a `_build_id` but no part
  // marker. Fall back to the visible Component copy rather than treating them as
  // unpaired — an un-guarded orphan is the exact bug this file exists for.
  //
  // 🚨 'side' IS TESTED BEFORE 'stone', AND THE ORDER IS LOAD-BEARING. The copy on a
  // side line reads "Side stones × 2 (3 of 3)", which CONTAINS the word "stone" — so the
  // old `indexOf('stone')` test classifies a side as the CENTRE. That matters far
  // more than a mislabelled row: `repair()` decides a build is complete when it can
  // see a centre, so a side stone masquerading as one would keep a centre-less
  // mounting alive in the cart. Same substring trap as `sku:` and "Half-Drilled" —
  // it only ever fails in the direction that looks fine.
  function roleOf(item) {
    var p = partOf(item);
    if (p) return p;
    var pr = props(item);
    /* A SIZED RING'S TWO LINES carry no Component and no `Sold as`: the charge is told apart by its product,
       everything else on the token is the ring. Read before the substring ladder below, which has no word for
       either. */
    if (pr[SR_PAIR]) return isSizing(item) ? 'sizing' : 'product';
    /* THE PRODUCT-PAGE PAIR SPEAKS A THIRD VOCABULARY. matching-chain.js posts no
       `_rb_part` and no `Component`; its visible property is `Sold as`, reading
       "Pendant (1 of 2)" and "Matching chain (2 of 2)". Read AFTER Component, so a
       line carrying both keeps the builder's word. Same ladder, same order. */
    var sold = !pr['Component'] && pr[SOLD_AS] ? String(pr[SOLD_AS]) : '';
    var c = (pr['Component'] || sold).toLowerCase();
    // 🚨 'chain' AND 'side' BOTH GO BEFORE 'stone', for the same reason. The copy on
    // a chain line reads "Matching chain" and contains none of the other words
    // TODAY — but this whole ladder exists because a substring test only ever fails
    // in the direction that looks fine, and the day someone writes "Chain (with
    // stone)" or relabels it, a chain silently becomes the CENTRE and `repair()`
    // keeps a centre-less mounting alive on the strength of it. Order it defensively
    // now rather than discover it in a customer's cart.
    if (c.indexOf('chain') >= 0) return 'chain';
    /* 'stud' EARLY, WITH THE OTHER ADD-ON WORDS. The jacket picker posts
       "Matching studs (2 of 2)" beside "Earring jackets (1 of 2)". Neither string
       contains any rung below, so today the order is not load-bearing — but this
       ladder exists because a substring test only ever fails in the direction that
       looks fine, and "stud" sits one letter from "stone" in a catalogue that
       writes both. Placed here it cannot be reached by a reworded stone line.
       ⚠️ The JACKET half is deliberately NOT named here: it falls through to
       'product' below, because the jacket is the finished piece the shopper is
       buying — the peer of the pendant on a chain pair. */
    if (c.indexOf('stud') >= 0) return 'studs';
    // "Accent stones: …" CONTAINS "stone": its rung sits above 'stone' too (the builder always writes `_rb_part`)
    if (c.indexOf('accent') >= 0) return 'accent';
    // "Second stone" is a side (owner Q6, 2026-09-25) and CONTAINS "stone": its rung sits above 'stone' too
    if (c.indexOf('second stone') >= 0) return 'side';
    if (c.indexOf('side') >= 0) return 'side';
    if (c.indexOf('stone') >= 0) return 'stone';
    if (c.indexOf('setting') >= 0 || c.indexOf('mounting') >= 0) return 'setting';
    /* 🚨 A `Sold as` LINE THE LADDER DID NOT NAME IS THE PRODUCT ITSELF — "Pendant
       (1 of 2)" — and it is deliberately NOT forced into the build vocabulary. On a
       product-page pair the pendant is the finished piece the shopper is buying, not
       a mounting waiting for a stone; read as 'setting' it would be the thing
       `repair()` deletes when no centre is in sight, i.e. a pendant a customer paid
       for, taken out of their cart by the guard written to protect them. This role is
       the first wall; `repair()`'s `_build_id` scope is the second. */
    if (sold) return 'product';
    return null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------------------------------------------------------------- repair */
  // What the last repair() actually changed, by kind — the parked note says which.
  var removedSettings = 0, removedCharges = 0, reducedSettings = 0;
  var removedLoose = 0;   // how many of removedSettings were settings outside a valid build; read by notify()
  // Returns a promise resolving to the number of lines it removed or brought down.
  function repair(cart) {
    var byBuild = {}, loose = [];
    cart.items.forEach(function (it) {
      /* 🚨 `buildOf`, NEVER `pairOf` — THIS PASS IS SCOPED TO `_build_id` GROUPS. A
         product-page pair (`_chain_set`, `_jacket_set`) has no orphan: a pendant and
         a pair of jackets are finished pieces, a chain is a necklace and studs are
         earrings we sell on their own, so either half survives the other
         (CLAUDE.md: "the chain is NOT load-bearing"). Widened to every pair key, a
         pendant read as a mounting would be DELETED from a paying customer's cart by
         the guard written to protect them. verify_cart_build.py [10] executes both
         forms: the widened one must take the pendant, and this one must not. */
      var b = buildOf(it);
      if (!b) {
        // Not part of a build. A setting-typed line goes whatever pair key it claims (a `_chain_set` or `_jacket_set`
        // pair is a finished pendant or jacket, never a setting); every other unbuilt line is a product we sell.
        if (isSettingType(it)) loose.push(it);
        return;
      }
      (byBuild[b] = byBuild[b] || []).push(it);
    });
    var orphans = [];
    Object.keys(byBuild).forEach(function (b) {
      var group = byBuild[b];
      /* 🚨 THE CENTRE IS WHAT MAKES A BUILD A RING — NOT "any stone".
         With side stones in the cart this test has to name the centre explicitly.
         Written as "does any stone remain", removing the CENTRE from a three-stone
         build leaves the mounting alive on the strength of its two sides: a bare
         mounting plus a loose pair, checkout-able, which is precisely the sale this
         file exists to refuse.

         The asymmetry is the owner's rule from 2026-08-02 and is unchanged — the
         SETTING is the half that cannot stand alone. Side stones are calibrated
         goods we sell loose, so they stay for the same reason the centre stone does
         when the setting is removed. Only the mounting is ever taken. */
      var hasCentre = group.some(function (i) { return roleOf(i) === 'stone'; });
      /* THE SECOND WALL (owner 2026-09-17, Codex review-mu54pwk3-npeono): a line TYPED as a setting stays only as the
         one setting of a valid build (validBuildSetting), whatever its properties claim. A setting the rule below
         already takes (a real build that lost its centre) keeps that rule's message; the rest are bare settings. */
      group.forEach(function (i) {
        if (isSettingType(i) && !(!hasCentre && roleOf(i) === 'setting') && !validBuildSetting(i, group)) loose.push(i);
      });
      /* ACCENT STONES AND THEIR EMPTY MOUNTING GO TOGETHER: a mounting typed as empty with no accent line in its build is
         a ring with empty seats, so it goes (with its sizing charge), and an accent line with no mounting in its build
         goes too. The centre stone, a product of its own, stays as always. */
      var hasAccent = group.some(function (i) { return roleOf(i) === 'accent'; });
      var settings = group.filter(function (i) { return roleOf(i) === 'setting'; });
      var emptyNoAccent = settings.some(isEmptyMount) && !hasAccent;
      if (hasCentre && !emptyNoAccent) {
        if (!settings.length) group.forEach(function (i) { if (roleOf(i) === 'accent') orphans.push(i); });
        return;
      }
      // …and the setting's sizing charge with it: the charge sizes the mounting, and cannot stand without it
      group.forEach(function (i) {
        if (roleOf(i) === 'setting' || roleOf(i) === 'sizing') orphans.push(i);
        if (roleOf(i) === 'accent') orphans.push(i);   // the accent line is paid for the mounting it fills
      });
    });
    /* A RING SIZING CHARGE WITHOUT ITS RING (owner 2026-09-17: the charge is a line inside the ring, never an item of
       its own). The same asymmetry as a build: the RING is a product and is never taken; its charge cannot stand
       alone. A charge whose `_sr_pair` token no ring line carries — or that carries no token at all — pays for
       nothing, so it goes. Reached when a ring left the cart some way that skipped this file's remove control. */
    var ringTokens = {};
    cart.items.forEach(function (it) {
      var t = props(it)[SR_PAIR];
      // A bare setting about to be removed is no ring: a charge on its token goes WITH it, in this same pass (the
      // session brake stops a second pass from reloading, so a charge left for later would sit in a stale cart).
      if (t && !isSizing(it) && loose.indexOf(it) < 0) ringTokens[String(t)] = true;
    });
    cart.items.forEach(function (it) {
      if (isSizing(it) && !ringTokens[String(props(it)[SR_PAIR] || '')]) orphans.push(it);
    });
    orphans = orphans.concat(loose);   // the bare settings (THE SECOND WALL above), removed like any orphan
    /* 🚨 AND A SETTING NEVER OUTNUMBERS ITS CENTRE STONE (Codex review-mu5i3ght-gafx1o). A build's quantity changes as
       one item now, so its parts disagree only in a cart changed some other way -- and a setting at 2 over one stone
       is a bare mounting at checkout, the sale this file exists to refuse. The same asymmetry: the SETTING is brought
       down to the quantity of stone it is made around; the stone, a product in its own right, is never touched. */
    // once each: a builder ring's charge can be an orphan of its build AND of its token
    var fixes = orphans.filter(function (item, n) { return orphans.indexOf(item) === n; })
      .map(function (item) { return { item: item, to: 0 }; });
    Object.keys(byBuild).forEach(function (b) {
      // (`line`, not `i`: the centre test above is a control anchor in verify_cart_build.py and must stay unique)
      var stones = byBuild[b].filter(function (line) { return roleOf(line) === 'stone'; });
      if (!stones.length) return;                        // a build with no centre: its setting is an orphan above
      var most = stones.reduce(function (sum, i) { return sum + (i.quantity || 0); }, 0);
      /* …and an EMPTY mounting never above its accent sets (Codex review-mw0pcx8i-yrucze: two mountings and two centres
         over one accent charge passed untouched). The same asymmetry: the accent line is the stones, the mounting is
         brought down to the rings they fill; nothing here ever adds a charge. (No accent line at all: the mounting is
         an orphan above.) The cart guard holds checkout unless there is ONE accent line at the mounting's quantity. */
      byBuild[b].forEach(function (i) {
        if (loose.indexOf(i) >= 0) return;   // a bare setting goes (THE SECOND WALL): never also brought down
        if (roleOf(i) === 'setting' && (i.quantity || 0) > most) fixes.push({ item: i, to: most });
      });
      var accents = byBuild[b].filter(function (line) { return roleOf(line) === 'accent'; });
      var sets = accents.reduce(function (sum, i) { return sum + (i.quantity || 0); }, 0);
      if (accents.length) byBuild[b].forEach(function (i) {
        if (roleOf(i) !== 'setting' || !isEmptyMount(i) || loose.indexOf(i) >= 0) return;
        var cap = Math.min(most, sets), had = fixes.filter(function (f) { return f.item === i; })[0];
        if (had) had.to = Math.min(had.to, cap);                 // one change per line: the lower quantity wins
        else if ((i.quantity || 0) > cap) fixes.push({ item: i, to: cap });
      });
      /* …and a builder ring's sizing charge never above its one setting: a charge over no ring is still a charge.
         (Below it, the cart guard holds checkout and says so; nothing here ever adds a charge.) */
      var mounts = byBuild[b].filter(function (line) { return roleOf(line) === 'setting' && loose.indexOf(line) < 0; });
      var rings = mounts.length === 1 ? Math.min(mounts[0].quantity || 0, most) : null;
      if (rings !== null && accents.length && isEmptyMount(mounts[0])) rings = Math.min(rings, sets);
      byBuild[b].forEach(function (line) {
        if (rings !== null && roleOf(line) === 'sizing' && (line.quantity || 0) > rings) {
          fixes.push({ item: line, to: rings });
        }
        // an accent line likewise: never more accent sets than rings they fill
        if (rings !== null && roleOf(line) === 'accent' && (line.quantity || 0) > rings) {
          fixes.push({ item: line, to: rings });
        }
      });
    });
    removedSettings = 0;
    removedLoose = 0;
    removedCharges = 0;
    reducedSettings = 0;
    if (!fixes.length) return Promise.resolve(0);

    // Remove by line KEY, never by index. Indexes shift as lines are removed, so
    // a loop over indexes deletes the wrong rows from the second one onward.
    /* 🚨 A REMOVAL THAT FAILED IS NOT A REMOVAL (Codex review-mu3u5g1z). This counted every POST as a
       success: a stale line key, a 422 or any 4xx left the bare mounting in the cart, the caller reloaded,
       and the session brake then stopped the next pass from trying again — so the one thing this guard
       exists to prevent, a mounting checkout-able without its centre stone, survived quietly. The response
       is checked, and /cart.js is read back: only keys that are really gone count. */
    return fixes.reduce(function (chain, fix) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: fix.item.key, quantity: fix.to })
        }).then(function (r) {
          if (!r || !r.ok) throw new Error('change.js ' + ((r && r.status) || '?'));
        }).catch(function () { /* counted by the read-back, never here */ });
        /* ONE REFUSED CHANGE MUST NOT SKIP THE REST (Codex review-mu56uu98-n6g2x5): each settles on its own, so a 422
           or a dropped request for the first line still lets every later line be fixed; the read-back below decides
           what really landed. builder-settings-hidden/test_cart_orphans.cjs [4] refuses the first of two. */
      });
    }, Promise.resolve()).then(function () { return getCart(); })
      .then(function (fresh) {
        var items = (fresh && fresh.items) || [];
        // Only what really landed counts: a removed line is gone, a brought-down setting holds its new quantity.
        var landed = fixes.filter(function (fix) {
          var line = items.filter(function (i) { return i.key === fix.item.key; })[0];
          return fix.to === 0 ? !line : !!line && line.quantity === fix.to;
        });
        if (landed.length < fixes.length) {
          try {
            window.console.warn('[rb-cart-pair] ' + (fixes.length - landed.length) + ' orphan line(s) could not be fixed');
          } catch (e) {}
        }
        landed.forEach(function (fix) {
          if (fix.to > 0) { if (!isSizing(fix.item)) reducedSettings++; }
          else if (isSizing(fix.item)) removedCharges++;
          else { removedSettings++; if (loose.indexOf(fix.item) >= 0) removedLoose++; }
        });
        // Only the ones actually fixed are reported; 0 leaves the caller's brake unset, so the next
        // page load tries again instead of presenting a bare mounting as a cart line.
        return landed.length;
      });
  }

  // ⚠️ THE MESSAGE HAS TO SURVIVE THE RELOAD. The repair ends in `location.reload()`,
  // so a notice painted before it flashes for a frame and is gone — the customer
  // sees an item vanish from their cart and is told nothing. Park the text and
  // render it on the way back in.
  var NOTE_KEY = 'rb-cart-note';
  /* 🚨 A NOTE IS FOR THE NEXT PAGE, SO IT IS TAKEN WHEN A PAGE ARRIVES -- NOT WHEN A PASS RUNS (found 2026-09-24 in a
     real cart test). A reload is only requested; a pass already queued (the drawer watch below, a cart signal) ran in
     the moment before the page went, and showParkedNote() then took the note just parked for the NEXT page and showed
     it on the one being thrown away, so the shopper never saw it. The note is read and cleared here, once, as the
     script starts; a note parked later on this page is left for the next one. */
  var ARRIVED = null;
  try { ARRIVED = sessionStorage.getItem(NOTE_KEY); if (ARRIVED) sessionStorage.removeItem(NOTE_KEY); } catch (e) {}
  var CARRY = ARRIVED;
  /* ...AND IT SURVIVES THIS PAGE RELOADING ITSELF (Codex review-mufgo27v-vzalho): a page that arrives with the note can
     reload at once (a second removal, the final-sale backfill), and the shopper would only glimpse it. Every reload this
     file starts goes through reloadPage(), which parks the note again -- ahead of any new one, never twice. (One reload,
     the unknown-cart branch in onChange, keeps location.reload(): it parks its own note, and verify_cart_items.cjs
     anchors on that text.) */
  function reloadPage() {
    if (CARRY) {
      try {
        var next = sessionStorage.getItem(NOTE_KEY);
        if (!next || next.indexOf(CARRY) < 0) sessionStorage.setItem(NOTE_KEY, next ? CARRY + ' ' + next : CARRY);
      } catch (e) {}
    }
    location.reload();
  }

  function notify(n) {
    if (!n) return;
    var said = [];
    if (removedSettings) {
      var piece = removedSettings === 1 ? 'setting' : 'settings';
      // A bare setting never had a gemstone, so nothing "comes straight back": point to the builder instead.
      said.push('We removed ' + (removedSettings === 1 ? 'a ' : removedSettings + ' ') + piece +
        ' from your cart. A setting is made around its gemstone, so we do not sell ' + (removedLoose
          ? 'one on its own — you can design a piece with it in our builder.'
          : 'one on its own — pick a stone for it in the builder and it comes straight back.'));
    }
    if (reducedSettings) {
      said.push((reducedSettings === 1
        ? 'We changed the quantity of a ring setting in your cart to match its gemstone'
        : 'We changed the quantity of ' + reducedSettings + ' ring settings in your cart to match their gemstones') +
        ': a setting is made around its gemstone, so we do not sell one on its own.');
    }
    if (removedCharges) {
      said.push(removedCharges === 1
        ? 'We removed a ring sizing charge from your cart: the ring it was for is no longer in it.'
        : 'We removed ' + removedCharges + ' ring sizing charges from your cart: the rings they were for are no longer in it.');
    }
    if (!said.length) return;
    try { sessionStorage.setItem(NOTE_KEY, said.join(' ')); } catch (e) {}
  }

  function showParkedNote() {
    var msg = ARRIVED;           // the note this page ARRIVED with (see ARRIVED); shown once
    ARRIVED = null;
    if (!msg) return;
    var box = document.createElement('div');
    box.className = 'rb-cart-note';
    box.setAttribute('role', 'status');
    box.textContent = msg;
    var page = document.querySelector('#main-cart-items');
    if (page) { page.insertBefore(box, page.firstChild); return; }
    /* 🚨 OFF THE CART PAGE THE NOTE WENT INTO THE CLOSED DRAWER (found 2026-09-23): the item was gone and nothing said
       why. It now goes where the site already shows cart changes -- the cart drawer, opened the way the header's cart
       icon and Add to cart open it -- at the top, under the drawer's header. cart-drawer.js may define the element
       after this runs, so it opens once the element is ready. cart-note-drawer/test_note.cjs. */
    var drawer = document.querySelector('cart-drawer');
    var inner = drawer && drawer.querySelector('.drawer__inner');
    if (inner) {
      var head = inner.querySelector('.drawer__header');
      inner.insertBefore(box, head ? head.nextSibling : inner.firstChild);
      var openIt = function () { try { if (typeof drawer.open === 'function') drawer.open(); } catch (e) {} };
      if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(openIt);
      else openIt();
      return;
    }
    document.body.insertBefore(box, document.body.firstChild);
  }

  /* ------------------------------------------------------- words and links */
  // The per-part control is CHANGE, never Remove — "remove the stone" is not a thing
  // anyone means; they mean "pick a different one", and offering Remove there is
  // exactly what let a bare setting reach checkout.
  var PAGES = {
    ring:    { settings: '/pages/ring-builder',    stones: '/pages/ring-gemstones' },
    pendant: { settings: '/pages/pendant-builder', stones: '/pages/pendant-gemstones' },
    earring: { settings: '/pages/earring-builder', stones: '/pages/earring-gemstones' }
  };
  var LABEL = { ring: 'Ring', pendant: 'Pendant', earring: 'Earrings' };

  /* 🚨 THE SHOP'S OWN MONEY FORMAT, so a group's figures read exactly like `{{ x | money }}` beside them. It was a
     hand-written '$' + whole dollars, which is right for this store today and wrong the day a second currency or a
     cents price appears. `theme.settings.money_with_currency_format` is `shop.money_format` (js-variables.liquid —
     misnamed there); it is written in the shop's currency, so a shopper paying in a CONVERTED currency
     (`Shopify.currency.rate` other than 1) gets the browser's formatting of that currency instead. */
  function formatWith(fmt, cents) {
    var m = String(fmt).match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return null;
    function fix(decimals, thousands, point) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? point + parts[1] : '');
    }
    var v = {
      amount: function () { return fix(2, ',', '.'); },
      amount_no_decimals: function () { return fix(0, ',', '.'); },
      amount_with_comma_separator: function () { return fix(2, '.', ','); },
      amount_no_decimals_with_comma_separator: function () { return fix(0, '.', ','); },
      amount_with_apostrophe_separator: function () { return fix(2, "'", '.'); },
      amount_no_decimals_with_space_separator: function () { return fix(0, ' ', ','); },
      amount_with_space_separator: function () { return fix(2, ' ', ','); },
      amount_with_period_and_space_separator: function () { return fix(2, ' ', '.'); }
    }[m[1]];
    return v ? String(fmt).replace(m[0], v()).replace(/<[^>]*>/g, '') : null;
  }
  function money(cents) {
    cents = Math.round(cents || 0);
    try {
      var cur = window.Shopify && window.Shopify.currency;
      var converted = !!(cur && cur.rate && Number(cur.rate) !== 1);
      var fmt = window.theme && window.theme.settings && window.theme.settings.money_with_currency_format;
      if (fmt && !converted) {
        var out = formatWith(fmt, cents);
        if (out) return out;
      }
      if (cur && cur.active && window.Intl) {
        return new window.Intl.NumberFormat(document.documentElement.lang || undefined,
          { style: 'currency', currency: cur.active }).format(cents / 100);
      }
    } catch (e) {}
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }

  function changeHref(item, which) {
    var p = props(item);
    var kind = p['_rb_kind'] || 'ring';
    var pages = PAGES[kind] || PAGES.ring;
    var q = p['_rb_q'] || '';
    if (which === 'setting') {
      // straight back to the setting's own configure view.
      // ⚠️ `_rb_q` ALREADY CONTAINS `style=` — appending it again emitted
      // `?style=225825&…&style=225825&configure=1`. URLSearchParams takes the
      // last, so it happened to work, which is exactly why it would have sat
      // there. Set it through URLSearchParams instead of string-concatenating.
      var u = new URLSearchParams(q);
      if (p['_rb_style']) u.set('style', p['_rb_style']);
      u.set('configure', '1');
      return pages.settings + '?' + u.toString();
    }
    // the stone grid, still carrying the setting so nothing is re-chosen twice
    var origin = /(^|&)origin=lab(&|$)/.test(q) ? '-lab' : '';
    return pages.stones.replace('-gemstones', '-gemstones' + origin) + '?' + q;
  }

  // With several parts in one item, the product titles alone do not say which stone is
  // which — "1.43 ct Blue Sapphire" reads identically as a centre and as a side.
  var PART_LABEL = { setting: 'Setting', stone: 'Center stone', side: 'Side stones', accent: 'Accent stones',
                     chain: 'Matching chain', studs: 'Matching studs', sizing: 'Ring sizing' };
  /* THE OPTIONAL PARTS AN ITEM CAN CARRY, and the word each one's own Remove uses.
     A builder BUILD takes a chain from its review step; a product-page PAIR takes
     exactly one of these and is named after it. Kept as a list rather than two
     `role === 'chain'` tests so a third add-on is a line here, not a new branch
     someone has to remember to write. */
  var ADDON_ROLES = ['chain', 'studs'];
  var ADDON_REMOVE = { chain: 'Remove chain', studs: 'Remove studs' };
  /* The metal half is a SETTING on a ring and a MOUNTING on a pendant or earring —
     the vocabulary `RB.KINDS[kind].mount` uses on every builder step. Read off the
     line's own `_rb_kind`; the cart holds no shards and no engine, so the two-word
     table lives here rather than importing RB. */
  function partLabel(which, kind, item) {
    if (which === 'setting') return kind === 'ring' ? 'Setting' : 'Mounting';
    if (which === 'product') return soldAsLabel(item);
    if (which === 'side' && item && isSecondStone(item)) return 'Second stone';
    return PART_LABEL[which];
  }
  /* THE PRODUCT-PAGE PAIR'S OWN WORDS. Its lines carry no `_rb_kind` and no Component,
     so the only vocabulary on them is the `Sold as` copy matching-chain.js wrote —
     "Pendant (1 of 2)". Reused with its counter stripped rather than typing a second
     one; the chain half already equals PART_LABEL.chain. */
  function soldAsLabel(item) {
    return String(props(item)[SOLD_AS] || '').replace(PART_OF_RE, '').trim();
  }

  /* 🚨 THE DENOMINATOR IS FROZEN AT ADD-TO-CART AND AN ADD-ON'S OWN REMOVE CAN
     FALSIFY IT. `Component` is a line-item property written once by
     `RB.addToCart`, so after the chain is dropped the survivors still read
     "Setting (1 of 3)" and "Center stone (2 of 3)" over a TWO-part build — and that
     is precisely the confusion the counter was fixed for on 2026-08-19, where a
     third line read as "not part of this ring". It prints on the packing slip
     Stuller works from, so a fulfiller reading "1 of 3" goes looking for a part
     that was never ordered.

     ⚠️ ONLY THE DENOMINATOR MOVES. The chain is always posted LAST, so removing it
     leaves every surviving part's position unchanged — 1 stays 1, 2 stays 2.
     ⚠️ REWRITTEN FROM THE LINE'S OWN STRING, never recomposed from a template. The
     copy differs per wave ("Setting" / "Both mountings") and per seat count
     ("Side stones × 4"), so rebuilding it here would be a second copy of
     `RB.addToCart`'s wording that drifts the next time either is edited.
     ⚠️ THE PRODUCT-PAGE PAIR'S COUNTER IS THE SAME SHAPE IN A DIFFERENT PROPERTY —
     "Pendant (1 of 2)" in `Sold as` — and is rewritten by this same rule: dropping
     the chain leaves "Pendant (1 of 1)". `counterField` says which property. */
  var COUNTER_FIELDS = ['Component', SOLD_AS];
  function counterField(p) {
    var i;
    for (i = 0; i < COUNTER_FIELDS.length; i++) {
      if (PART_OF_RE.test(String(p[COUNTER_FIELDS[i]] || ''))) return COUNTER_FIELDS[i];
    }
    return null;
  }

  /* BACKFILL THE FINAL-SALE NOTE ON BUILDS ADDED BEFORE IT SHIPPED (Codex reviews 2026-09-15). Carts persist
     for days, so without this a piece built yesterday would check out today with no final-sale line at checkout.
     ONE QUEUE for every older build line in the cart, posted one at a time like renumber() (every property
     restated, because a change.js replaces them all; quantity restated). Then /cart.js is READ BACK, and only
     when every build piece line carries the note does it reload once — a property change mints a new line key,
     and the item's controls hold the old ones.
     ⚠️ AT MOST TWO ATTEMPTS PER TAB. The counter is stored BEFORE posting and cleared only after a verified
     success, so a change that will not stick can never reload in a loop. A failure that changed nothing does not
     reload; one that changed some lines reloads (fresh keys) and may try once more. No storage, no attempt: the
     item still shows the note, and that one older cart lacks it at checkout.
     AND ON ENGRAVED LINES ADDED BEFORE THEIRS SHIPPED (owner 2026-09-26: an engraved piece carries the same line,
     "Final sale — engraved to order, not returnable", written by the engraving box or the ring page's size menu), by
     the same queue, the same read-back and the same two tries. A line that has any `Returns` already keeps it. */
  var SALE_TRIES = 'rb-final-sale-tries';
  var saleRunning = false;
  function isBuildPiece(item) {
    var g = pairOf(item), r = roleOf(item);
    return !!(g && g.key === BUILD && (r === 'setting' || r === 'stone' || r === 'side'));
  }
  // A line that should carry the final-sale line and does not: a build piece, or an engraved piece.
  function needsSale(item) {
    return (isBuildPiece(item) || engravingOf(item).length > 0) && !props(item)[FINAL_SALE_KEY];
  }
  function saleTextFor(item) { return isBuildPiece(item) ? FINAL_SALE : ENGRAVED_FINAL_SALE; }
  function backfillFinalSale(queue) {
    if (saleRunning || !queue.length) return;
    try {
      var tries = parseInt(sessionStorage.getItem(SALE_TRIES) || '0', 10) || 0;
      if (tries >= 2) return;
      sessionStorage.setItem(SALE_TRIES, String(tries + 1));
    } catch (e) { return; }
    saleRunning = true;
    var changed = 0;
    queue.reduce(function (chain, item) {
      return chain.then(function () {
        var updated = Object.assign({}, props(item));
        updated[FINAL_SALE_KEY] = saleTextFor(item);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: updated })
        }).then(function (r) {
          if (!r.ok) throw new Error('change.js ' + r.status);
          changed++;
        });
      });
    }, Promise.resolve())
      .then(getCart)
      .then(function (fresh) {
        var missing = ((fresh && fresh.items) || []).filter(needsSale);
        if (missing.length) throw new Error(missing.length + ' build or engraved line(s) still without the note');
        try { sessionStorage.removeItem(SALE_TRIES); } catch (e) {}
        reloadPage();
      })
      .catch(function (err) {
        saleRunning = false;
        try {
          window.console.warn('[rb-cart-pair] final-sale note not saved on every build or engraved line: ' + (err && err.message));
        } catch (e) {}
        if (changed) reloadPage();
      });
  }

  function renumber(removed, siblings) {
    var left = siblings.filter(function (x) { return x.item.key !== removed.item.key; });
    if (!left.length) return Promise.resolve();
    return left.reduce(function (chain, x) {
      var props0 = props(x.item);
      var field = counterField(props0);
      // No counter on this line (an older cart, or a build added before the counter
      // shipped) — leave it exactly as it is rather than inventing one.
      if (!field) return chain;
      var label = String(props0[field]);
      var m = label.match(PART_OF_RE);
      var next = label.replace(PART_OF_RE, '(' + m[1] + ' of ' + left.length + ')');
      if (next === label) return chain;
      var patch = {};
      patch[field] = next;
      var updated = Object.assign({}, props0, patch);
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // ⚠️ `quantity` MUST BE RESTATED. /cart/change.js treats an omitted
          // quantity as unchanged for some shapes and as 0 for others depending on
          // how the line is addressed; sending it explicitly is the difference
          // between relabelling a line and silently deleting it.
          body: JSON.stringify({ id: x.item.key, quantity: x.item.quantity,
                                 properties: updated })
        });
      });
    }, Promise.resolve());
  }

  /* AN ADD-ON'S OWN REMOVE — the one control an OPTIONAL part needs.

     🚨 THE ITEM'S remove control TAKES EVERY PART, and that is right for every other
     part: a mounting, a centre and its sides are one piece. A chain is not one of
     them — it is a separate necklace the shopper added and can change their mind
     about without abandoning the pendant.

     ⚠️ ONE LINE, NOT THE GROUP. It posts `quantity: 0` for this key alone and
     reloads; `repair()` then sees a build that still has its setting and its centre
     and does nothing, which is the correct outcome and worth stating because the
     orphan guard is the thing most likely to be blamed if this ever misbehaves. */
  function addonRemove(part, siblings) {
    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'rb-group__link';
    rm.textContent = ADDON_REMOVE[part.role] || 'Remove';
    /* 🚨 A REMOVAL SHOPIFY REFUSED MUST NOT RENUMBER OR RELOAD (Codex review-mu3ud2xq). fetch RESOLVES on a
       422 or a stale key, so this used to renumber the surviving lines and reload as if the chain were gone:
       the shopper still pays for it, while its siblings' "(2 of 3)" counters now describe a build that never
       happened — wrong in the cart, on the packing slip and at checkout. The response is checked and
       /cart.js read back; only when the line is really gone are the counters rewritten. */
    rm.addEventListener('click', function () {
      rm.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: part.item.key, quantity: 0 })
      })
        .then(function (r) {
          if (!r || !r.ok) throw new Error('change.js ' + ((r && r.status) || '?'));
          return getCart();
        })
        .then(function (fresh) {
          var still = ((fresh && fresh.items) || []).some(function (i) { return i.key === part.item.key; });
          if (still) throw new Error('the line is still in the cart');
          return renumber(part, siblings);
        })
        .then(function () { reloadPage(); })
        .catch(function (err) {
          rm.disabled = false;
          try {
            window.console.warn('[rb-cart-pair] could not remove the ' + (part.role || 'add-on') + ': ' + (err && err.message));
          } catch (e) {}
        });
    });
    return rm;
  }

  /* ------------------------------------------------------- one item, one row */
  /* 🚨 THE ITEM IS DRAWN IN THE THEME'S OWN ROW, NEVER A ROW OF ITS OWN (owner 2026-09-17).
     The old card was a <tr> of its own with one cell spanning every column, so nothing inside it could sit in the
     Availability, Quantity or Total column (and before that, a <div> dropped into the <tbody> became an anonymous
     cell that dragged the photo column to 219px and blurred every photograph — 2026-08-26). Drawing inside the
     main line's row keeps every column the theme's: the photo cell, the Availability cell, the theme's own
     quantity control and remove control, and both Total cells (the phone one and the computer one). Only the
     contents of those cells change; the other lines' rows are hidden, never removed, because their quantity
     inputs are still posted by the cart form (`updates[]`) when the shopper checks out. */
  var GROUPED = 'data-rb-grouped';        // on the row that draws a group: the kind ('build', 'pair', 'sized')
  var PART_ROW = 'data-rb-part';          // on a hidden row whose line is drawn inside another row
  var SEEN = 'data-rb-seen';              // on every row of a joined line this pass has read (see watch())
  var groups = {};                        // row id -> what that row's quantity and remove controls act on
  var lastCart = null;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }
  function closest(node, sel) { return node && node.closest ? node.closest(sel) : null; }
  function lineTotal(item) { return item.final_line_price != null ? item.final_line_price : (item.line_price || 0); }
  // One item's worth of a part: what the part costs per unit of the ITEM's quantity (a side pair costs both stones).
  function perItem(x, q) { return Math.round(lineTotal(x.item) / (q || 1)); }
  /* A LINE'S OPTIONS ON ONE LINE — "Emerald · 14K Yellow Gold", a ring size as "Size 7", "None" left out — the same
     rule the cart templates print under every ordinary line's name (cart_liquid_edits.py, `sr-line-options`), so a part
     of a group and an ordinary line read alike. From /cart.js `options_with_values`; the variant title split on " / "
     when that is absent. */
  function optionsLine(item) {
    var opts = item.options_with_values;
    if (!opts || !opts.length) {
      opts = String(item.variant_title || '').split(' / ').map(function (v) { return { name: '', value: v }; });
    }
    return opts.filter(function (o) {
      var v = String((o && o.value) || '').trim();
      return v && v !== 'None' && v !== 'Default Title';
    }).map(function (o) {
      return o.name === 'Ring Size' ? 'Size ' + String(o.value).trim() : String(o.value).trim();
    }).join(' \u00b7 ');
  }
  // Only a same-origin path, never `//host` — /cart.js says where a product lives; nothing here composes it.
  function pageLink(url, text) {
    if (typeof url !== 'string' || !/^\/(?!\/)/.test(url)) return null;
    var a = el('a', 'rb-group__link', text || 'Change');
    a.href = url;
    return a;
  }
  function actions(price, control, oldPrice) {
    var box = el('div', 'rb-group__actions');
    var priceEl = el('span', 'rb-group__price product-option');
    if (oldPrice) {                       // discounted part: old price struck through, as on an ordinary cart line
      priceEl.appendChild(el('s', 'cart-item__old-price', oldPrice));
      priceEl.appendChild(document.createTextNode(' '));
    }
    priceEl.appendChild(document.createTextNode(price));
    box.appendChild(priceEl);
    if (control) box.appendChild(control);
    return box;
  }
  function counterless(item) {
    var f = counterField(props(item));
    return f ? String(props(item)[f]).replace(PART_OF_RE, '').trim() : '';
  }
  // How many of this part one ITEM holds: 1 for nearly everything, 2 for a side pair posted as quantity 2.
  function multOf(x, q) { return Math.max(1, Math.round((x.item.quantity || 1) / (q || 1))); }
  /* HOW MANY SIDE STONES ONE RING TAKES, from the side line's own copy: `RB.addToCart` writes "Side stones × 2 (3 of 3)"
     over a quantity of seats × rings (the seat count is 1, 2 or 4 across the cohort); a build added before the count
     was stated reads "Side stones (2)". Null when neither says -- and then the build is not drawn as one item. */
  function seatsOf(item) {
    if (isSecondStone(item)) return 1;
    var c = String(props(item)['Component'] || '');
    var m = c.match(/\u00d7\s*(\d+)/) || c.match(/^\s*Side stones\s*\((\d+)\)/i);
    var n = m ? parseInt(m[1], 10) : NaN;
    return n > 0 ? n : null;
  }
  /* A SECOND STONE (owner Q6, 2026-09-25): on five toi et moi and two-centre designs the one side stone is written
     "Second stone (3 of 3)" -- ONE stone, named in words instead of "Side stones × 1". Its row is tagged "Second
     stone" (partLabel) and counts as one seat (seatsOf). */
  function isSecondStone(item) {
    return /^\s*Second stone\b/i.test(String(props(item)['Component'] || ''));
  }

  /* WHAT A GROUP IS, decided per key; null draws nothing and leaves the ordinary rows. */
  function planOf(g) {
    var parts = g.parts;
    function role(r) { return parts.filter(function (x) { return x.role === r; }); }
    var addons = parts.filter(function (x) { return ADDON_ROLES.indexOf(x.role) >= 0; });
    var plan = { key: g.key, id: g.id, surface: g.surface, parts: parts, addons: addons, pieces: [], others: [] };
    var known;
    if (g.key === BUILD) {
      var setting = role('setting')[0], stone = role('stone')[0];
      if (!setting || !stone) return null;                 // repair() handles orphans
      var kind = props(setting.item)['_rb_kind'] || 'ring';
      plan.type = 'build';
      plan.anchor = setting;
      plan.stone = stone;
      plan.label = (LABEL[kind] || 'Ring') + ' (completed)';
      /* EVERY side line, not the first. A mounting takes 1, 2 or 4 side seats
         (measured across the cohort: 111 designs take 2, 10 take 1, 2 take 4), and
         all of them are billed. */
      plan.pieces = [setting, stone].concat(role('side'), role('accent'));
      /* A SIZED BUILDER RING'S CHARGE (owner 2026-09-17): drawn inside the ring. EXACTLY one, on a ring build -- two
         charges, or one on a pendant, stay ordinary rows, where the cart guard's note says what to fix. */
      var fees = role('sizing');
      if (fees.length > 1 || (fees.length && kind !== 'ring')) return null;
      plan.fee = fees[0] || null;
      known = plan.pieces.concat(addons, fees);
    } else if (g.key === SR_PAIR) {
      /* A SIZED RING: EXACTLY one ring and one charge on the token, or nothing is drawn. A lone ring, or a token
         shared by two rings, stays as ordinary rows, where the cart guard's own note says what to fix — drawing
         a group would hide the very lines that note is about. A lone charge is removed by repair(). */
      var rings = role('product'), fees = role('sizing');
      if (rings.length !== 1 || fees.length !== 1) return null;
      plan.type = 'sized';
      plan.anchor = rings[0];
      plan.fee = fees[0];
      plan.label = 'Ring + ring sizing';
      known = [rings[0], fees[0]];
    } else {
      /* A PRODUCT-PAGE PAIR (`_chain_set` or `_jacket_set`). A pair whose add-on has already been removed is one
         line, and one line is an ordinary row. A lone chain likewise — it is still a necklace, sold on its own. */
      var product = role('product')[0];
      if (!product || !addons.length) return null;
      plan.type = 'pair';
      plan.anchor = product;
      // Both halves of the label are copy already on the lines — "Pendant" from the product's own `Sold as`,
      // "Matching chain" from PART_LABEL — named after the add-on the pair actually carries.
      plan.label = soldAsLabel(product.item) + ' + ' + String(partLabel(addons[0].role) || '').toLowerCase();
      known = [product].concat(addons);
    }
    /* 🚨 NO LINE IS HIDDEN WITHOUT BEING DRAWN. Every row of the group is hidden, so a line this plan has no
       place for (a second setting, a role nothing names) is still listed as a part and still in the total —
       a hidden line that is still charged is exactly the "total below checkout" defect of 2026-08-19. */
    plan.others = parts.filter(function (x) { return known.indexOf(x) < 0; });
    plan.q = plan.anchor.item.quantity || 1;
    /* 🚨 AND ONLY WHILE ITS QUANTITIES AGREE (Codex review-mu5i3ght-gafx1o). One item at quantity N holds N of every
       part -- a build's side-stone line a whole number of times N -- and nothing else is an item. A ring at 2 over one
       sizing charge drawn as "Ring sizing · $11" would hide an under-charge behind a tidy item; ungrouped, its two rows
       show what the cart holds and the cart guard explains it and holds checkout. A pair of products in skew is two
       products. A build's setting above its stone is brought down by repair() before this ever draws; its side stones
       must be exactly the seats its setting takes, for each ring. */
    var even = parts.every(function (x) {
      if (plan.type === 'build' && x.role === 'side') {
        // EXACTLY the seats the setting takes, per ring (Codex review-mu5icpvl-gj9enw): a ring needing two side stones
        // over one is an incomplete order, not an item; a count nobody stated is not guessed.
        var seats = seatsOf(x.item);
        return seats !== null && (x.item.quantity || 0) === plan.q * seats;
      }
      return (x.item.quantity || 0) === plan.q;
    });
    return even ? plan : null;
  }

  /* "Ring sizing, size 4 · $22": a sizing charge drawn as a line inside its ring (owner 2026-09-17) -- a ring page's ring
     and a builder ring alike. Spaces as text, not only as the flex gap, so the line reads and copies as one. */
  function sizingSub(size, amount) {
    var sub = el('div', 'rb-group__sub');
    sub.appendChild(el('span', null, 'Ring sizing' + (size ? ', size ' + size : '')));
    sub.appendChild(document.createTextNode(' '));
    var dot = el('span', null, '·');
    dot.setAttribute('aria-hidden', 'true');
    sub.appendChild(dot);
    sub.appendChild(document.createTextNode(' '));
    sub.appendChild(el('span', null, money(amount)));
    return sub;
  }

  /* ─────────────────────────────────────────────────────────── ENGRAVING (owner 2026-09-26; see ENGRAVING) ── */
  // The sides the shopper filled in: [{ side: 'front', text: 'FFA' }].
  function engravingOf(item) {
    var p = props(item), out = [];
    ENGRAVING.forEach(function (e) {
      var v = String(p[e[0]] == null ? '' : p[e[0]]).trim();
      if (v) out.push({ side: e[1], text: v });
    });
    return out;
  }
  /* "Engraving: FFA" — ONE OF THE PIECE'S OWN DETAILS, in its options line's quiet style, directly under "14K Yellow
     Gold" (owner 2026-09-26, on the first proposal — a full-size "Engraving, front: FFA · Complimentary" line under
     the price, which read like a separate charge: "that does not look polished"). A side is named only when it is
     not the plain front: "Engraving: A (front), B (back)", "Engraving: B (back)". No price and no "Complimentary":
     it is free, and nothing on the line says otherwise. */
  function engravingMeta(item) {
    var sides = engravingOf(item);
    if (!sides.length) return null;
    var text = (sides.length > 1 || sides[0].side !== 'front')
      ? sides.map(function (s) { return s.text + ' (' + s.side + ')'; }).join(', ')
      : sides[0].text;
    /* The font and fill the shopper chose in the ring builder, after the words: "Engraving: Forever Yours
       (inside) · Edwardian Script, black fill" (owner 2026-10-06). Nothing for the initials boxes. */
    var how = [String(props(item)['Engraving font'] || '').trim(),
               String(props(item)['Engraving color'] || '').trim().toLowerCase()]
      .map(function (v, i) { return v && i === 1 ? v + ' fill' : v; }).filter(Boolean).join(', ');
    return el('div', 'rb-group__meta sr-line-options rb-group__engraving',
              'Engraving: ' + text + (how ? ' \u00b7 ' + how : ''));
  }
  /* The final-sale line under an item whose piece is final sale: the piece's own note, and — when the item also
     holds an add-on — that the add-on stays returnable, in the add-on's own word and verb ("The matching chain is
     not final sale.", "The matching studs are ..."). One line for the whole item, as a build's (saleNote). */
  function pairSaleNote(plan) {
    var sale = saleOf(plan.anchor.item);
    if (!sale) return null;
    var addon = plan.addons.length ? String(partLabel(plan.addons[0].role) || 'add-on').toLowerCase() : '';
    return el('div', 'rb-group__note', sale + (addon
      ? '. The ' + addon + (/s$/.test(addon) ? ' are' : ' is') + ' not final sale.' : ''));
  }
  // The setting line's own engraving, never another cart build's words.
  function engravingCarry(item) {
    var p = props(item || {});
    var text = String(p['Inside engraving'] || '').trim();
    if (!text) return null;
    return { text: text, label: String(p['Engraving font'] || '').trim(),
             color: String(p['Engraving color'] || '').trim() || 'None' };
  }
  /* THE WORDS TRAVEL WITH THE FLOW, NOT WITH THE CLICK (Codex review-mv9c1jvh-nfj7ij, medium). A Change link opened with
     middle-click, "Open in new tab" or a long press never runs a click handler, and the new tab has no sessionStorage of
     its own: the builder then read an empty box, and the ring could be added again without its engraving. So the words
     are also saved when the link is DRAWN, in localStorage (shared by every tab, expiring, at most 20), under the link's
     own flow id. A flow id that starts with `c-` is a cart build that HAD engraving: its builder page keeps Add to cart
     blocked until it finds those words (ring-builder-pages.js engraveCarried). KEEP THE KEY AND THE LIFETIME EQUAL TO
     THAT FILE'S. */
  var ENGRAVE_FLOW_KEY = 'sr-rb-engrave-flow:', ENGRAVE_FLOW_LIFE = 6 * 60 * 60 * 1000, ENGRAVE_FLOW_MAX = 20;
  function engravingKeep(flow, carry) {
    try {
      var now = Date.now(), held = [];
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (!k || k.indexOf(ENGRAVE_FLOW_KEY) !== 0) continue;
        var rec = null;
        try { rec = JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) {}
        if (!rec || !(now - rec.at < ENGRAVE_FLOW_LIFE)) localStorage.removeItem(k);
        else held.push({ key: k, at: rec.at });
      }
      held.sort(function (x, y) { return y.at - x.at; });
      held.slice(ENGRAVE_FLOW_MAX - 1).forEach(function (h) { localStorage.removeItem(h.key); });
      localStorage.setItem(ENGRAVE_FLOW_KEY + flow, JSON.stringify({
        text: carry.text, label: carry.label, color: carry.color, flow: flow, at: now
      }));
    } catch (e) {}
  }
  function engravingChange(control, carry) {
    if (!control) return;
    // Only the opaque flow id enters the URL. Personalization stays in browser storage.
    var flow = (carry ? 'c-' : 'e-') + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    var url = new URL(control.href, location.href);
    url.searchParams.set('engrave_flow', flow);
    control.href = url.pathname + url.search;
    if (carry) engravingKeep(flow, carry);
    control.addEventListener('click', function () {
      try {
        if (carry) sessionStorage.setItem('sr-rb-engrave', JSON.stringify({
          text: carry.text, label: carry.label, color: carry.color, flow: flow
        }));
        else sessionStorage.removeItem('sr-rb-engrave');
      } catch (e) {}
    });
  }
  // Every other visible property on a line, the theme's way ("Name: value"; see DRAWN), or null.
  function otherProps(item) {
    var p = props(item), list = null;
    Object.keys(p).forEach(function (k) {
      var v = String(p[k] == null ? '' : p[k]).trim();
      if (!v || k.charAt(0) === '_' || DRAWN.indexOf(k) >= 0) return;
      if (!list) list = el('dl', 'rb-group__props');
      var row = el('div', 'product-option');
      row.appendChild(el('dt', null, k + ':'));
      row.appendChild(document.createTextNode(' '));
      row.appendChild(el('dd', null, v));
      list.appendChild(row);
    });
    return list;
  }
  // A piece's final-sale line: the note stored on its line, else the engraving's, else none.
  function saleOf(item) {
    var v = props(item)[FINAL_SALE_KEY];
    if (v) return String(v);
    return engravingOf(item).length ? ENGRAVED_FINAL_SALE : '';
  }

  /* A PIECE ENGRAVED ON ITS OWN — no chain, no sizing charge, ONE line (owner 2026-09-26). Drawn in its row's
     details cell the way a sized ring is (draw(), 'sized'): "Pendant + engraving", the theme's own name link, its
     options (and a ring's size) with the engraving under them, its price and Change, its availability tag and the
     final-sale line. Everything else in the row stays the theme's — photo, Availability column, quantity,
     remove and totals — because it IS one line and the theme's own controls already act on all of it; it is
     never entered in `groups`, so the capture listeners below leave those controls alone. */
  function drawEngraved(row, item) {
    var details = row.querySelector('.cart-item__details');
    if (!details || row.hasAttribute(ENGRAVED)) return;
    var inline = details.querySelector('.sr-avail');
    var discounts = Array.prototype.map.call(details.querySelectorAll('.discounts li'), function (li) {
      return li.cloneNode(true);
    });
    var box = el('div', 'rb-group');
    box.appendChild(el('div', 'rb-group__label', (ENGRAVED_KIND[item.product_type] || 'Piece') + ' + engraving'));
    var name = details.querySelector('.cart-item__name');        // the theme's own title link, kept as it is
    box.appendChild(name || el('div', 'cart-item__name', item.product_title || item.title));
    // A ring page's size is a property, not an option: "14K Yellow Gold · Size 7", as on a sized ring.
    var size = String(props(item)['Ring Size'] || '').trim();
    var meta = [optionsLine(item), size ? 'Size ' + size : ''].filter(Boolean).join(' · ');
    if (meta) box.appendChild(el('div', 'rb-group__meta sr-line-options', meta));
    var engraved = engravingMeta(item);
    if (engraved) box.appendChild(engraved);
    var extra = otherProps(item);
    if (extra) box.appendChild(extra);
    var q = item.quantity || 1;
    var now = Math.round(lineTotal(item) / q);
    var was = Math.round((item.original_line_price != null ? item.original_line_price : lineTotal(item)) / q);
    box.appendChild(actions(money(now), pageLink(item.url), was > now ? money(was) : null));
    if (inline) box.appendChild(inline.cloneNode(true));
    var sale = saleOf(item);
    if (sale) box.appendChild(el('div', 'rb-group__note', sale));
    if (discounts.length) {
      var ul = el('ul', 'discounts list-unstyled');
      ul.setAttribute('role', 'list');
      discounts.forEach(function (li) { ul.appendChild(li); });
      box.appendChild(ul);
    }
    while (details.firstChild) details.removeChild(details.firstChild);
    details.appendChild(box);
    row.setAttribute(ENGRAVED, '1');
    row.classList.add('rb-group-row');
    row.classList.add('rb-group--engraved');
  }

  /* 🚨 A BUILDER RING SHOWS ITS SIZE (found 2026-09-26; queued by the chief of staff). The size is on the setting's
     line ("Ring size", written by RB.addToCart for every ring build), and the item drew it only in a sizing charge's
     line, "Ring sizing, size 6 · $22" -- so a ring in its stocked size, which carries no charge, never showed it in the
     cart. The setting now reads "14K White Gold · Size 7", the way a ring page's sized ring reads "14K Yellow Gold ·
     Size 4"; a charge's line still names the size too. Nothing for a pendant or earring build (the builder never
     sizes them), nor for a setting whose own options already name a size. */
  function buildRingSize(plan) {
    var item = plan.anchor.item;
    if ((props(item)['_rb_kind'] || 'ring') !== 'ring') return '';
    if ((item.options_with_values || []).some(function (o) { return o && o.name === 'Ring Size'; })) return '';
    var size = String(props(item)['Ring size'] || '').trim();
    if (!size) return '';
    // "To be confirmed" (a build added before a size was chosen) reads "Size to be confirmed".
    return 'Size ' + (/^\d/.test(size) ? size : size.charAt(0).toLowerCase() + size.slice(1));
  }

  function partRow(plan, x, chips) {
    var wrap = el('div', 'rb-group__part');
    var body = el('div', 'rb-group__parttext');
    var tag = partLabel(x.role, props(x.item)['_rb_kind'] || 'ring', x.item) || counterless(x.item);
    if (tag) body.appendChild(el('div', 'rb-group__tag', tag));
    // an accent line names its stones from the builder's own words ("Natural blue sapphire, AA, 24 stones"), never
    // the service product's "$250" variant
    var accentWords = x.role === 'accent'
      ? String(props(x.item)['Component'] || '').replace(/^Accent stones:\s*/i, '').replace(PART_OF_RE, '').trim() : '';
    body.appendChild(el('div', 'rb-group__name', accentWords || x.item.product_title || x.item.title));
    var vt = x.role === 'accent' ? null : optionsLine(x.item);
    if (plan.type === 'build' && x === plan.anchor) vt = [vt, buildRingSize(plan)].filter(Boolean).join(' \u00b7 ');
    if (vt) body.appendChild(el('div', 'rb-group__meta sr-line-options', vt));
    /* The part's engraving, as one of its details under its options, and any visible property this file has no
       words for (owner 2026-09-26: the engraving on a pendant bought with its chain was wiped with the theme's
       details). */
    var engraved = engravingMeta(x.item);
    if (engraved) body.appendChild(engraved);
    var extra = otherProps(x.item);
    if (extra) body.appendChild(extra);
    var control = null;
    if (ADDON_ROLES.indexOf(x.role) >= 0) {
      control = addonRemove(x, plan.parts);
    } else if (x.role === 'product') {
      /* 🚨 NO BUILDER LINK ON A PRODUCT-PAGE PAIR. `changeHref` composes a builder URL out of
         `_rb_kind`/`_rb_q`/`_rb_style`, none of which this line carries, so it would default to the RING builder's
         configure view. The one destination that exists is the product's own page, which /cart.js names. */
      control = pageLink(x.item.url);
    } else if (plan.type === 'build' && (x === plan.anchor || x === plan.stone)) {
      control = pageLink(changeHref(x.item, x.role));
      /* Each Change starts its own engraving edit flow. Unengraved builds CLEAR the prior handoff. */
      engravingChange(control, engravingCarry(plan.anchor && plan.anchor.item));
    }
    /* ⚠️ NO "Change" ON A SIDE ROW, and none on an add-on: both existing builder destinations are wrong for them
       (the stones grid sets the CENTRE, the configure view picks the mounting), and a link that silently
       overwrites the wrong half of the build is worse than no link. The add-on has its own Remove instead. */
    var srNow = perItem(x, plan.q);
    var srWas = Math.round((x.item.original_line_price != null ? x.item.original_line_price : lineTotal(x.item)) / (plan.q || 1));
    body.appendChild(actions(money(srNow), control, srWas > srNow ? money(srWas) : null));
    if (chips && chips[x.item.key]) body.appendChild(chips[x.item.key]);
    /* EACH LINE OF A PAIR SHOWS ITSELF (owner, 2026-09-08). A pendant is photographed hanging on a stock chain,
       so one pendant photograph for the pair showed a chain the shopper had not chosen beside the one they had.
       A BUILD keeps its single composed render instead (in the row's photo cell; see draw). */
    if (plan.type === 'pair' && x.item.image) {
      var src = String(x.item.image);
      var im = el('img', 'rb-group__thumb');
      // Shopify serves a sized variant off the same URL; 160 covers a 56px box at 2x.
      im.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      im.alt = '';                           // the name is already read out beside it
      im.loading = 'eager';                  // always on screen in an open cart; a blank box reads as a defect
      im.addEventListener('error', function once() {
        im.removeEventListener('error', once);
        if (im.parentNode) im.parentNode.removeChild(im);
        wrap.classList.remove('rb-group__part--media');
      });
      wrap.classList.add('rb-group__part--media');
      wrap.appendChild(im);
    }
    wrap.appendChild(body);
    return wrap;
  }

  function saleNote(plan) {
    var sale = '';
    plan.pieces.forEach(function (x) {
      var v = props(x.item)[FINAL_SALE_KEY];
      if (!sale && v) sale = String(v);
    });
    /* One note beneath an item that also holds a matching chain reads as covering the chain (Codex review), so it
       says the chain is not final sale. */
    return (sale || FINAL_SALE) + (plan.addons.length
      ? '. The ' + String(partLabel(plan.addons[0].role) || 'add-on').toLowerCase() + ' is not final sale.'
      : '');
  }

  /* HOW MANY OF THIS ITEM THE CART MAY HOLD. Every part's quantity input carries the most Shopify will sell of that
     line (`max`, from the cart's Liquid: the variant's quantity rule, and its stock when the stock is tracked and
     cannot be oversold — a one-of-a-kind stone is 1). The item may hold as many as its scarcest part allows. */
  function limitOf(plan) {
    var max = null, limiter = null;
    plan.parts.forEach(function (x) {
      var input = x.el.querySelector('.quantity__input');
      var raw = input && input.getAttribute('max');
      var cap = raw === null || raw === undefined || raw === '' ? NaN : Math.floor(parseInt(raw, 10) / multOf(x, plan.q));
      if (isNaN(cap)) return;
      if (max === null || cap < max) { max = cap; limiter = x; }
    });
    // ⚠️ NEVER BELOW WHAT THE CART HOLDS: a number input above its max fails the form's own validation, and the
    // cart form is what checkout submits.
    return { max: max === null ? null : Math.max(max, plan.q), limiter: limiter };
  }

  function syncButtons(row) {
    var input = row.querySelector('.quantity__input');
    if (!input) return;
    var v = parseInt(input.value, 10);
    var min = parseInt(input.getAttribute('min'), 10), max = parseInt(input.getAttribute('max'), 10);
    var minus = row.querySelector('.quantity__button[name="minus"]');
    var plus = row.querySelector('.quantity__button[name="plus"]');
    // The theme's own rule (QuantityInput.validateQtyRules), which does not run for an item's input: see onChange.
    if (minus && !isNaN(min)) minus.classList.toggle('disabled', v <= min);
    if (plus && !isNaN(max)) plus.classList.toggle('disabled', v >= max);
  }

  function draw(plan) {
    var row = plan.anchor.el, page = plan.surface === 'page';
    // What the rows already say, read BEFORE the main row's details are replaced: each line's availability tag in
    // its details (the cart page's copy there carries `sr-avail--inline`, hidden wherever the column shows) and in
    // the page's Availability cell, and any discount the theme listed under a line.
    var inline = {}, column = {}, discounts = [];
    plan.parts.forEach(function (x) {
      var a = x.el.querySelector('.cart-item__details .sr-avail');
      var b = x.el.querySelector('.cart-item__availability .sr-avail');
      if (a) inline[x.item.key] = a.cloneNode(true);
      if (b) column[x.item.key] = b.cloneNode(true);
      Array.prototype.forEach.call(x.el.querySelectorAll('.discounts li'), function (li) {
        discounts.push(li.cloneNode(true));
      });
    });

    row.setAttribute(GROUPED, plan.type);
    row.setAttribute('data-rb-group', plan.key);
    row.classList.add('rb-group-row');
    row.classList.add('rb-group--' + plan.type);
    plan.parts.forEach(function (x) {
      if (x === plan.anchor) return;
      x.el.setAttribute('hidden', 'hidden');
      x.el.setAttribute(PART_ROW, '1');
    });

    /* THE DETAILS CELL: the item's label, then its parts. */
    var details = row.querySelector('.cart-item__details');
    if (details) {
      var box = el('div', 'rb-group');
      box.appendChild(el('div', 'rb-group__label', plan.label));
      if (plan.type === 'sized') {
        /* A SIZED RING READS AS THE RING (owner 2026-09-17): its own name, "14K Yellow Gold · Size 4", its price and
           Change, then "Ring sizing, size 4 · $22" as a line inside it — never an item with a quantity of its own —
           and the ring's own final-sale property, the one checkout shows. */
        var ring = plan.anchor, fee = plan.fee;
        var name = details.querySelector('.cart-item__name');     // the theme's own title link, kept as it is
        box.appendChild(name || el('div', 'cart-item__name', ring.item.product_title || ring.item.title));
        var size = String(props(ring.item)['Ring Size'] || '').trim();
        var meta = [optionsLine(ring.item), size ? 'Size ' + size : ''].filter(Boolean).join(' \u00b7 ');
        if (meta) box.appendChild(el('div', 'rb-group__meta sr-line-options', meta));
        // An engraved ring's engraving, one of its details under "14K Yellow Gold · Size 4" (owner 2026-09-26).
        var ringEngraved = engravingMeta(ring.item);
        if (ringEngraved) box.appendChild(ringEngraved);
        var ringExtra = otherProps(ring.item);
        if (ringExtra) box.appendChild(ringExtra);
        box.appendChild(actions(money(perItem(ring, plan.q)), pageLink(ring.item.url)));
        box.appendChild(sizingSub(size, perItem(fee, plan.q)));
        if (inline[ring.item.key]) box.appendChild(inline[ring.item.key]);
        var sale = props(ring.item)[FINAL_SALE_KEY];
        if (sale) box.appendChild(el('div', 'rb-group__note', String(sale)));
        plan.others.forEach(function (x) { box.appendChild(partRow(plan, x, inline)); });
      } else if (plan.type === 'pair') {
        var list = el('div', 'rb-group__parts');
        [plan.anchor].concat(plan.others, plan.addons).forEach(function (x) {
          list.appendChild(partRow(plan, x, inline));
        });
        box.appendChild(list);
        /* AN ENGRAVED PIECE'S FINAL-SALE LINE, ONCE, UNDER THE WHOLE ITEM (owner 2026-09-26: inside the pendant it
           wrapped, doubled the pendant's height and "does not look polished"). A build's sits under its pieces too. */
        var pairNote = pairSaleNote(plan);
        if (pairNote) box.appendChild(pairNote);
      } else {
        var pieces = el('div', 'rb-group__parts');
        plan.pieces.concat(plan.others).forEach(function (x) { pieces.appendChild(partRow(plan, x, null)); });
        box.appendChild(pieces);
        if (plan.fee) box.appendChild(sizingSub(String(props(plan.anchor.item)['Ring size'] || '').trim(),
                                                perItem(plan.fee, plan.q)));
        /* WHAT THIS ITEM IS (owner 2026-09-16): the shopper chose the setting and the stone and we set it for them,
           which is what makes it final sale, so it says CUSTOM rather than "made to order" — once, for the build. */
        var custom = chip(CUSTOM_PIECE, CUSTOM_WHEN, '#5A4E7A', '#E8E3F1');
        if (page) custom.classList.add('sr-avail--inline');
        box.appendChild(custom);
        box.appendChild(el('div', 'rb-group__note', saleNote(plan)));
        if (plan.addons.length) {
          var extra = el('div', 'rb-group__parts');
          plan.addons.forEach(function (x) { extra.appendChild(partRow(plan, x, inline)); });
          box.appendChild(extra);
        }
      }
      if (discounts.length) {
        var ul = el('ul', 'discounts list-unstyled');
        ul.setAttribute('role', 'list');
        discounts.forEach(function (li) { ul.appendChild(li); });
        box.appendChild(ul);
      }
      while (details.firstChild) details.removeChild(details.firstChild);
      details.appendChild(box);
      // A pair has no one photograph, so on the cart page its details span the photo column (the CSS hides that cell).
      if (plan.type === 'pair' && details.tagName === 'TD') details.colSpan = 2;
    }

    /* THE PHOTO CELL. 🚨 A BUILD SHOWS ITS COMPOSED RENDER, NOT THE MOUNTING'S STOCK PHOTO (owner 2026-08-18: "in
       the cart, they don't show the final product"). `_rb_img` is written by `RB.buildThumb` at add-to-cart — the
       picture the shopper approved on review. It replaces the photograph INSIDE the theme's own image box, so the
       render has exactly the size and place of every other line's photo (owner 2026-09-17: centred like them).
       ⚠️ The fallback chain is load-bearing: an earring build has no render, a cart from before it shipped has none,
       and a render that 404s later falls back to the stored photo rather than a broken image. */
    if (plan.type === 'build') {
      var media = row.querySelector('.cart-item__media');
      var stored = plan.anchor.item.image || plan.stone.item.image || null;
      var render = props(plan.anchor.item)['_rb_img'] || stored;
      if (media && render) {
        // The link over the photo goes to the bare mounting's page — not a page for the ring they built.
        var cover = media.querySelector('.cart-item__link');
        if (cover && cover.parentNode) cover.parentNode.removeChild(cover);
        var img = media.querySelector('img');
        if (img) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        } else {
          img = el('img', 'rb-group__render--own');
          media.appendChild(img);
        }
        img.classList.add('rb-group__render');
        if (render !== stored && stored) {
          img.addEventListener('error', function once() {   // ONCE: a stored photo that also fails must not loop
            img.removeEventListener('error', once);
            img.src = stored;
          });
        }
        img.src = render;
        img.alt = '';
      }
    }

    /* THE AVAILABILITY CELL (cart page, from 1280px): each line's tag, in the column like every other item's. */
    var cell = row.querySelector('.cart-item__availability');
    if (cell) {
      var stack = el('div', 'rb-group__chips');
      if (plan.type === 'build') {
        var c = chip(CUSTOM_PIECE, CUSTOM_WHEN, '#5A4E7A', '#E8E3F1');
        stack.appendChild(c);
        plan.addons.forEach(function (x) { if (column[x.item.key]) stack.appendChild(column[x.item.key]); });
      } else if (plan.type === 'pair') {
        [plan.anchor].concat(plan.others, plan.addons).forEach(function (x) {
          if (column[x.item.key]) stack.appendChild(column[x.item.key]);
        });
      } else if (column[plan.anchor.item.key]) {
        stack.appendChild(column[plan.anchor.item.key]);
      }
      while (cell.firstChild) cell.removeChild(cell.firstChild);
      cell.appendChild(stack);
    }

    /* 🚨 THE TOTAL CELLS SUM EVERY LINE THAT IS ACTUALLY IN THE CART. Written as `setting + stone` this once omitted
       every side line — a total BELOW what checkout charges, the worst failure available here, because nothing
       errors. ⚠️ A line price already includes its quantity; multiplying again would double a side pair. Both
       Total cells: the theme draws one for phones and one for computers. */
    var final = 0, original = 0;
    plan.parts.forEach(function (x) {
      final += lineTotal(x.item);
      original += (x.item.original_line_price != null ? x.item.original_line_price : lineTotal(x.item));
    });
    Array.prototype.forEach.call(row.querySelectorAll('.cart-item__totals .cart-item__price-wrapper'), function (w) {
      while (w.firstChild) w.removeChild(w.firstChild);
      if (original > final) w.appendChild(el('s', 'cart-item__old-price price price--end', money(original)));
      w.appendChild(el('span', 'price price--end', money(final)));
    });

    /* THE QUANTITY CELL: the theme's own control, held to the scarcest part. */
    var input = row.querySelector('.quantity__input');
    var limit = limitOf(plan);
    if (input && limit.max !== null) input.setAttribute('max', String(limit.max));
    syncButtons(row);
    var qcell = row.querySelector('.cart-item__quantity');
    if (qcell && plan.type === 'build' && limit.limiter && limit.limiter.role === 'stone' && limit.max <= plan.q) {
      // Owner 2026-09-17 (rule 4): the + greyed out, and why — that exact stone can only be sold once.
      var why = el('p', 'sr-qty-note', 'One-of-a-kind center stone.');
      why.setAttribute('style', QTY_NOTE_STYLE);
      qcell.appendChild(why);
    }
    // The remove control names the item it removes, not the one line it was printed for.
    var rm = row.querySelector('cart-remove-button a, cart-remove-button button');
    var title = plan.anchor.item.title;
    var said = rm && rm.getAttribute('aria-label');
    if (said && title && said.indexOf(title) >= 0) rm.setAttribute('aria-label', said.replace(title, plan.label));

    remember(plan);
  }

  function remember(plan) {
    var row = plan.anchor.el;
    groups[row.id] = {
      row: row,
      label: plan.label,
      surface: plan.surface,
      line: plan.anchor.line,
      q: plan.q,
      max: limitOf(plan).max,
      parts: plan.parts.map(function (x) {
        return { key: x.item.key, identity: identity(x.item), qty: x.item.quantity, mult: multOf(x, plan.q),
                 input: x.el.querySelector('.quantity__input') };
      })
    };
  }

  function group(cart) {
    var saleQueue = [];   // older build lines without the final-sale note, across every build
    /* 🚨 TWO ID PREFIXES, AND THE DRAWER IS THE ONE THAT MATTERS. The cart PAGE
       renders `id="CartItem-N"` (main-cart-items.liquid); the DRAWER renders
       `id="CartDrawer-Item-N"` (cart-drawer.liquid), and the drawer is on nearly
       every storefront page. Both can be on /cart at once, so a group is formed from
       the rows of ONE surface: the key carries the prefix. */
    var rows = document.querySelectorAll('[id^="CartItem-"],[id^="CartDrawer-Item-"]');
    if (!rows.length) return;
    var items = cart.items || [];
    // ⚠️ KEYED ON `key|id`, NEVER THE ID ALONE. The ids are minted by different
    // scripts, so a collision is improbable — and improbable is not impossible; two
    // that happened to agree would merge a ring with an unrelated pendant.
    var found = {};
    var engraved = [];    // pieces engraved on their own, one line each (drawEngraved)
    Array.prototype.forEach.call(rows, function (row) {
      var m = (row.id || '').match(/^(CartDrawer-Item|CartItem)-(\d+)$/);
      if (!m) return;
      row.setAttribute(SEEN, '1');                      // read by this pass, joined or not (see watch())
      var line = parseInt(m[2], 10);
      var item = items[line - 1];
      var g = item && pairOf(item);
      if (!g) {
        if (item && engravingOf(item).length) engraved.push({ row: row, item: item });
        return;
      }
      var gk = m[1] + '|' + g.key + '|' + g.id;
      (found[gk] = found[gk] || { key: g.key, id: g.id, surface: m[1] === 'CartItem' ? 'page' : 'drawer', parts: [] })
        .parts.push({ el: row, item: item, role: roleOf(item), line: line });
    });

    Object.keys(found).forEach(function (gk) {
      var plan = planOf(found[gk]);
      if (!plan) {
        /* A PRODUCT-PAGE PAIR LEFT WITH ONE LINE — its chain or studs removed — is an ordinary line again (planOf),
           and an engraved one is still an engraved piece, so it reads like one. ONLY those two keys: a ring left
           without its sizing charge, or a build line on its own, stays exactly as the theme draws it, where the
           cart guard's note says what to fix. */
        var lone = found[gk].parts;
        if ((found[gk].key === CHAIN_SET || found[gk].key === JACKET_SET) && lone.length === 1 &&
            engravingOf(lone[0].item).length) {
          engraved.push({ row: lone[0].el, item: lone[0].item });
        }
        return;
      }
      if (plan.type === 'build') {
        // The build's OWN parts — what final sale covers. Never an add-on (a matching chain stays returnable).
        plan.pieces.forEach(function (x) {
          if (props(x.item)[FINAL_SALE_KEY]) return;
          if (saleQueue.some(function (i) { return i.key === x.item.key; })) return;   // the page and the drawer
          saleQueue.push(x.item);
        });
      }
      if (plan.anchor.el.getAttribute(GROUPED)) { remember(plan); return; }
      draw(plan);
    });
    engraved.forEach(function (x) { drawEngraved(x.row, x.item); });
    // Engraved lines without their final-sale line (added before it shipped), wherever they are drawn.
    items.forEach(function (it) {
      if (engravingOf(it).length && needsSale(it) && !saleQueue.some(function (i) { return i.key === it.key; })) {
        saleQueue.push(it);
      }
    });
    backfillFinalSale(saleQueue);
  }

  /* ------------------------------------------------------- one item, one quantity */
  /* 🚨 THE THEME'S CONTROLS, ACTING ON EVERY PART (owner 2026-09-17, rule 3). The quantity input and the remove
     control in a group's row are the theme's own, and left to the theme they change ONE line: the ring without its
     sizing charge, a setting without its stone. So their two events are taken first — a listener on the document in
     the capture phase runs before the theme's own on `cart-items`, `cart-drawer-items` and `cart-remove-button` —
     and only for a row this file has drawn a group in. Every other row is the theme's, untouched.

     ONE REQUEST FOR THE WHOLE ITEM: /cart/update.js with every part's line key (Shopify: "the key can be the line
     item's variant_id or key"), so no in-between cart ever holds a ring with the wrong number of charges. The
     sections the theme itself re-renders after a change come back in the same response and are drawn the same way
     (cart.js updateQuantity), then the theme's own cart signal is published, which re-draws the group.

     ⚠️ EVERY PART'S INPUT CHANGES AT ONCE, BEFORE THE REQUEST. The hidden rows' inputs are still in the cart form
     (`updates[]`), and Enter in a quantity box or the Check out button submits that form natively — with the item's
     input at 2 and its parts at 1, that would be exactly the uneven cart this code exists to prevent. */
  var CHANGE_WAIT = 300;                   // the theme's ON_CHANGE_DEBOUNCE_TIMER (constants.js)
  var waits = {}, busy = {};

  function identity(item) {
    var p = props(item);
    return item.variant_id + '|' + Object.keys(p).sort().map(function (k) { return k + '=' + p[k]; }).join('&');
  }
  // A line's quantity in a cart Shopify returned: by key, or — because a key can change when a discount applies or
  // lapses — by what the line IS (variant and properties, which Shopify never lets two lines share).
  function lineIn(state, part) {
    var items = (state && state.items) || [], i;
    for (i = 0; i < items.length; i++) if (items[i].key === part.key) return items[i];
    for (i = 0; i < items.length; i++) if (identity(items[i]) === part.identity) return items[i];
    return null;
  }
  function groupOf(node) {
    var row = closest(node, '[' + GROUPED + ']');
    var grp = row && groups[row.id];
    return grp && grp.row === row ? grp : null;
  }
  function want(grp, value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 0) n = grp.q;
    if (grp.max !== null && n > grp.max) n = grp.max;
    return n;
  }
  function setInputs(grp, n) {
    grp.parts.forEach(function (p) { if (p.input) p.input.value = String(n === null ? p.qty : n * p.mult); });
    syncButtons(grp.row);
  }

  function onChange(e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    var grp = groupOf(input);
    // The item's own input only: the one in the row the group is drawn in (the parts' rows are hidden, not in it).
    if (!grp || grp.row.querySelector('.quantity__input') !== input) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    // A change while a request is out shows what that request is setting; it is not queued behind it.
    if (busy[grp.row.id]) { setInputs(grp, grp.pending); return; }
    var n = want(grp, input.value);
    setInputs(grp, n);
    clearTimeout(waits[grp.row.id]);
    waits[grp.row.id] = setTimeout(function () { setQuantity(grp, n); }, CHANGE_WAIT);
  }

  function onClick(e) {
    var button = closest(e.target, 'cart-remove-button');
    var grp = button && groupOf(button);
    if (!grp) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (busy[grp.row.id]) return;
    clearTimeout(waits[grp.row.id]);
    setInputs(grp, 0);
    setQuantity(grp, 0);
  }

  function sectionsOf(container) {
    try {
      var s = container && typeof container.getSectionsToRender === 'function' ? container.getSectionsToRender() : [];
      return Array.isArray(s) ? s : [];
    } catch (e) { return []; }
  }

  function post(updates, sections) {
    var body = { updates: updates };
    if (sections.length) {
      body.sections = sections.map(function (s) { return s.section; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (state) {
        if (!r.ok || !state || state.status || !state.items) {
          var err = new Error('');
          err.shopper = state && (state.description || state.message) ? String(state.description || state.message) : '';
          throw err;
        }
        return state;
      });
    });
  }

  // Draws the returned sections exactly as the theme's own updateQuantity does. False when there is nothing to draw
  // with (a container that is not the theme's), and the caller reloads instead.
  function paint(container, sections, state) {
    if (!sections.length || !state.sections) return false;
    var empty = state.item_count === 0;
    [container, document.querySelector('cart-drawer'), document.querySelector('.cart-order'),
     document.getElementById('main-cart-footer')].forEach(function (node) {
      if (node && node.classList) node.classList.toggle('is-empty', empty);
    });
    sections.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = state.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
    return true;
  }

  function announce(state) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cartUpdated', { detail: { message: 'Cart was updated' } })); } catch (e) {}
  }

  function showError(grp, message) {
    var id = (grp.surface === 'page' ? 'Line-item-error-' : 'CartDrawer-LineItemError-') + grp.line;
    var box = document.getElementById(id);
    var text = box && box.querySelector('.cart-item__error-text');
    if (text) {
      text.textContent = message || (window.cartStrings && window.cartStrings.error) ||
        'There was an error while updating your cart. Please try again.';
    }
  }

  function setQuantity(grp, n) {
    var id = grp.row.id;
    if (n === grp.q) { setInputs(grp, null); return; }
    busy[id] = true;
    grp.pending = n;
    var updates = {};
    grp.parts.forEach(function (p) { updates[p.key] = n * p.mult; });
    var container = closest(grp.row, 'cart-items') || closest(grp.row, 'cart-drawer-items');
    var sections = sectionsOf(container);
    try { if (container && container.enableLoading) container.enableLoading(grp.line); } catch (e) {}
    post(updates, sections)
      .then(function (state) {
        /* 🚨 ALL OR NOTHING. Shopify can take some quantities and not others — a stone sold elsewhere a moment
           ago — which would leave a ring with the wrong number of charges or a setting without its stone. Any
           part that did not land puts every part back as it was. */
        var off = grp.parts.filter(function (p) {
          var line = lineIn(state, p);
          return (line ? line.quantity : 0) !== n * p.mult;
        });
        if (!off.length) return state;
        if (n === 0) {
          /* 🚨 A REMOVAL SHOPIFY TOOK ONLY PART OF IS FINISHED, NEVER UNDONE (Codex review-mu5i3ght-gafx1o): a line the
             shopper asked to remove cannot be put back by a quantity once it is gone, and re-adding it would be a new
             add. The lines still there are removed again; whatever even that leaves is shown as it is, with the error,
             and repair() judges it on the next read (a charge without its ring, a setting without its stone). */
          var rest = {};
          grp.parts.forEach(function (p) { var line = lineIn(state, p); if (line) rest[line.key] = 0; });
          return post(rest, sections).then(function (again) {
            if (!grp.parts.some(function (p) { return !!lineIn(again, p); })) return again;
            throw new Error('');                                    // the catch reads the cart back and says so
          });
        }
        var back = {};
        grp.parts.forEach(function (p) { var line = lineIn(state, p); if (line) back[line.key] = p.qty; });
        return post(back, sections).then(function (again) {
          if (!paint(container, sections, again)) reloadPage(); else announce(again);
          var err = new Error('');
          err.painted = true;
          throw err;
        });
      })
      .then(function (state) {
        if (!paint(container, sections, state)) { reloadPage(); return; }
        announce(state);
      })
      .catch(function (err) {
        if (err && err.painted) { showError(grp, ''); return; }
        /* A REFUSED REQUEST IS CHECKED, NOT ASSUMED HARMLESS: the cart is read back, and if any part moved the page
           reloads so it shows what the cart really holds; otherwise the inputs go back and the theme's error spot
           says why. */
        return getCart().then(function (fresh) {
          function all(want) {
            return grp.parts.every(function (p) { var line = lineIn(fresh, p); return (line ? line.quantity : 0) === want(p); });
          }
          if (all(function (p) { return p.qty; })) {            // nothing moved: the boxes go back, the reason shows
            setInputs(grp, null);
            showError(grp, err && err.shopper);
            return;
          }
          /* 🚨 SOMETHING MOVED AND NOT EVERYTHING (Codex review-mu5icpvl-gj9enw): a removal that could not be finished,
             or a change that could not be put back. The page reloads to show what the cart really holds, and the note
             waiting for the reload says so, so nobody checks out a part they believe they removed. */
          if (!all(function (p) { return n * p.mult; })) {
            try {
              sessionStorage.setItem(NOTE_KEY, n === 0
                ? 'We could not remove all of \u201c' + grp.label + '\u201d from your cart. Please check your cart and remove what is left.'
                : 'We could not change the quantity of every part of \u201c' + grp.label + '\u201d. Please check the quantities in your cart.');
            } catch (e) {}
          }
          reloadPage();
        }, function () {
          /* THE CART COULD NOT EVEN BE READ BACK (Codex review-mu5ik86w-rx3yfo): what it holds is unknown, so the item on
             screen may no longer be true. It is not left to be acted on: the page reloads onto the real cart, and the
             note says the change could not be confirmed. */
          try {
            sessionStorage.setItem(NOTE_KEY, 'We could not confirm the change to \u201c' + grp.label +
              '\u201d. Please check your cart before you check out.');
          } catch (e) {}
          location.reload();
        });
      })
      .then(function () {
        busy[id] = false;
        try { if (container && container.disableLoading) container.disableLoading(grp.line); } catch (e) {}
      });
  }

  if (document.addEventListener) {
    document.addEventListener('change', onChange, true);
    document.addEventListener('click', onClick, true);
  }

  /* ------------------------------------------------------- is-empty sweep */
  /* 🚨 A CART WITH ITEMS IN IT, DRAWN AS AN EMPTY ONE (owner, 2026-09-07 on a
     phone; reproduced on desktop 2026-09-08 and traced the same day).

     `is-empty` is written into the markup by Liquid whenever the PAGE loaded
     with an empty cart (snippets/cart-drawer.liquid:50), and `component-cart.css:23`
     — `.is-empty .cart__contents { display:none }`, keyed on an ANCESTOR — hides
     the entire cart form while it is there. (That stylesheet is not mirrored in
     theme_work/; the rule was read off the live theme on 2026-09-08.) Only two pieces of
     theme code take the class off after an add, and both are the theme's own add
     handlers (product-form.js:105 and theme.js:4300, quick-add) — so an add path
     that posts the cart itself instead of going through one of them leaves the
     drawer displaying its count and its total over a hidden item list.

     matching-chain.js was the one that shipped. The RING BUILDER is not affected:
     it navigates to /cart after adding (ring-builder-pages.js:1648) and a page load
     re-bakes the class correctly. jacket-studs.js would have been, and clears it
     inline. The next add-on that renders the drawer in place will be too.

     So this is a second layer under the inline clear each picker does: this file
     already runs on every page and on every cart signal, which makes it the one
     place that can catch an add-on whose author forgets. It is a NET, not the
     fix — verify_cart_not_empty_class.py enforces the inline clear.

     ⚠️ REMOVES ONLY, AND ONLY WITH BOTH A COUNT AND RENDERED ROWS. There is no
     branch that ADDS the class, because a bug in one would hide a paying
     customer's cart. Putting it back is the theme's job (Liquid on load,
     cart.js on quantity changes) and the theme does that correctly. */
  function unhideCart(cart) {
    if (!cart || !(cart.item_count > 0)) return;
    /* ⚠️ TWO CONDITIONS, AND THE ROWS ARE THE LOAD-BEARING ONE. A count from
       /cart.js can be STALE: cart.js dispatches 'cartUpdated' synchronously,
       OUTSIDE the promise chain, before /cart/change.js has resolved
       (cart.js:215-220), so a run triggered by removing the last item can read a
       cart that still has it. Acting on that count alone would strip `is-empty`
       from markup the theme had correctly just re-rendered as empty, and since
       nothing here ever ADDS the class back, the shopper would be left looking at
       an empty cart with no "Your cart is empty" and a live Checkout button.
       The rendered rows cannot lie: Liquid wraps every row in `{% if cart != empty %}`
       (cart-drawer.liquid:138, main-cart-items.liquid:63), so no rows on screen
       means the empty markup is on screen, whatever a fetch in flight believes.
       (Fable review, 2026-09-08.)

       ⚠️ SEALED, AND USING querySelector ONLY. `document.getElementById` is absent
       from the picker's test DOM, and the first cut of this threw there — inside
       the success continuation of an add that had already gone through, where the
       throw is caught upstream and turned into a redirect to /cart. A shopper was
       one missing DOM method away from being bounced off the page they were on.
       Presentation must never be able to fail a completed add.

       THE ELEMENT LIST is every element the theme stamps or clears `is-empty` on:
       `cart-drawer` and `cart-drawer-items` in the drawer (cart-drawer.liquid:50,
       :122), `.cart-order`, `cart-items` and `#main-cart-footer` on /cart
       (main-cart-items.liquid:36, :38, :489), plus `.drawer__inner`, which Liquid
       never stamps but cart-drawer.js:96 clears anyway. `cart-items` matters: on
       /cart it is an ANCESTOR of the form (:38 wraps :60), and the rule that does
       the hiding is ancestor-keyed. */
    try {
      if (document.querySelector
          && document.querySelector('[id^="CartDrawer-Item-"],[id^="CartItem-"]')) {
        ['cart-drawer', 'cart-drawer-items', '.cart-order', 'cart-items',
         '#main-cart-footer', '.drawer__inner'].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el && el.classList) el.classList.remove('is-empty');
        });
      }
    } catch (e) { /* a class is never worth losing a completed add over */ }
  }

  /* ---------------------------------------------------------------- run */
  var running = false, pending = false;
  function run() {
    /* COALESCE, NEVER DROP. The theme fires its two cart signals on opposite
       sides of the section re-render (see the mount block at the foot of this
       file), so a run started by the early one can still be in flight when the
       useful one arrives. Dropping that second call is exactly how the grouping
       ends up applied to the pre-render DOM with nothing to re-apply it. */
    if (running) { pending = true; return; }
    running = true;
    showParkedNote();
    getCart().then(function (cart) {
      lastCart = cart;
      return repair(cart).then(function (n) {
        if (n) {
          // 🚨 RELOAD ONCE, EVER. The repair ends in a reload so the totals and
          // the checkout button agree with the cart — but if a removal silently
          // fails (a 422, a line key that moved), the next load finds the same
          // orphan and reloads again, forever, on the page where the customer
          // keeps their money. sessionStorage is the brake: a second pass that
          // still sees orphans leaves them visible and says nothing rather than
          // spinning. Cleared as soon as a clean cart is seen.
          /* A LANDED CHANGE ALWAYS RELOADS, UP TO A CAP (Codex review-mue3nw6g-04x7cy). `n` counts only changes the
             read-back in repair() confirmed, so every reload follows real progress and the cart shrinks each time.
             A one-reload brake drew the PRE-repair cart when a change that failed on one load landed on the next
             (the deleted line and old totals on screen, no note). MAX_RELOADS is the runaway backstop only.
             builder-settings-hidden/test_cart_orphans.cjs [10]. */
          var KEY = 'rb-cart-repaired', MAX_RELOADS = 3, done = 0;
          try { done = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) {}
          if (done >= MAX_RELOADS) {
            if (window.console) {
              console.warn('[rb-cart-pair] orphan line persisted after a repair '
                           + 'pass — not reloading again');
            }
            unhideCart(cart);
            group(cart);
            return;
          }
          try { sessionStorage.setItem(KEY, String(done + 1)); } catch (e) {}
          notify(n);
          reloadPage();
          return;
        }
        try { sessionStorage.removeItem('rb-cart-repaired'); } catch (e) {}
        unhideCart(cart);
        group(cart);
      });
    }).catch(function () { /* never let a cart guard break the cart */ })
      .then(function () {
        running = false;
        if (pending) { pending = false; setTimeout(run, 0); }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* 🚨 THE THEME DISPATCHES NONE OF `cart:refresh`, `cart:updated` OR
     `cart-drawer:open`. Those three names were subscribed to here and appear in
     exactly ONE file in the whole theme: this one. They were dead from the day
     they were written, so nothing ever re-grouped a build after a quantity change
     or a re-render. The two signals the theme really emits are:

       publish(PUB_SUB_EVENTS.cartUpdate)   cart.js:204   fired INSIDE the fetch
           .then(), AFTER the sections have been re-rendered. This is the correct
           hook and the one that does the work.
       document 'cartUpdated'               cart.js:215   dispatched SYNCHRONOUSLY,
           OUTSIDE the fetch chain — i.e. BEFORE the cart has actually changed.
           Useless alone; kept only as a backstop, and safe because run() re-reads
           /cart.js itself and the pending flag above re-runs it after the render.

     ⚠️ `subscribe` and `PUB_SUB_EVENTS` are `let`/`const` at the top level of a
     classic script, so they are lexical globals and are NOT properties of
     `window` — reference them bare and feature-test with `typeof`. Load order is
     constants → pubsub → cart → this file, all `defer`, so they are defined by
     the time this runs.

     Drawer OPEN needs no hook: the drawer's markup is server-rendered with the
     page, so the initial run() above already groups it. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(run, 0); });
  }
  document.addEventListener('cartUpdated', function () { setTimeout(run, 0); });

  /* 🚨 A RE-RENDER NOBODY ANNOUNCES. The theme's add button publishes the cart signal and THEN re-renders the drawer
     — and the drawer's own subscriber fetches the drawer section again and swaps it in a moment later still — so a
     run started by that signal can group rows that are then replaced by plain ones, with no signal left to say so.
     A watch on the two cart containers catches it: when a cart row appears that no pass has read, run again. Every
     row a pass reads is marked (group() stamps SEEN on each, joined or not), and a pass only ever adds attributes
     and children to rows it has already marked, so the watch cannot loop on the changes a pass itself makes. */
  var watched = [], queued = false;
  function stale() {
    if (!lastCart) return false;                       // the first pass is still out; it will read these rows
    var rows = document.querySelectorAll('[id^="CartItem-"],[id^="CartDrawer-Item-"]'), i;
    for (i = 0; i < rows.length; i++) {
      if (/^(?:CartDrawer-Item|CartItem)-\d+$/.test(rows[i].id || '') && !rows[i].hasAttribute(SEEN)) return true;
    }
    return false;
  }
  function watch() {
    if (!window.MutationObserver) return;
    ['cart-drawer', '#main-cart-items'].forEach(function (sel) {
      var host = document.querySelector(sel);
      if (!host || watched.indexOf(host) >= 0) return;
      watched.push(host);
      new window.MutationObserver(function () {
        if (queued || !stale()) return;
        queued = true;
        setTimeout(function () { queued = false; run(); }, 30);
      }).observe(host, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
